/* ========================================
   K7 MWT CLAMP
   ======================================== */

function getK7ClampText(wrap) {
  return wrap.querySelector('[data-k7-clamp-text], .k7-desc-clamp__text, .k7-mwt-clamp__text');
}

function syncK7ClampOverflow(wrap) {
  const toggle = wrap.querySelector('[data-k7-clamp-toggle]');
  const text = getK7ClampText(wrap);
  if (!toggle || !text) return;

  if (wrap.classList.contains('k7-mwt-clamp--phrase')) {
    toggle.hidden = false;
    return;
  }

  if (wrap.classList.contains('is-expanded')) {
    toggle.hidden = false;
    return;
  }

  toggle.hidden = false;
  const overflows = text.scrollHeight - text.clientHeight > 1;
  toggle.hidden = !overflows;
}

function initK7MwtClamp(root = document) {
  root.querySelectorAll('[data-k7-clamp]').forEach((wrap) => {
    if (wrap.dataset.k7Init === 'true') {
      syncK7ClampOverflow(wrap);
      return;
    }

    const toggle = wrap.querySelector('[data-k7-clamp-toggle]');
    if (!toggle) return;

    wrap.dataset.k7Init = 'true';

    toggle.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded
        ? toggle.dataset.collapse || toggle.dataset.expand
        : toggle.dataset.expand;
    });

    const measure = () => syncK7ClampOverflow(wrap);
    requestAnimationFrame(measure);
    if (document.fonts?.ready) {
      document.fonts.ready.then(measure);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initK7MwtClamp());
document.addEventListener('shopify:section:load', (event) => {
  initK7MwtClamp(event.target);
});
document.addEventListener('product:rerender', () => {
  setTimeout(() => initK7MwtClamp(), 100);
});
window.addEventListener('resize', () => {
  document.querySelectorAll('[data-k7-clamp]').forEach((wrap) => {
    if (wrap.dataset.k7Init === 'true') {
      syncK7ClampOverflow(wrap);
    }
  });
});

/* ========================================
   K7 FAQ
   ======================================== */

function initK7Faq(root = document) {
  root.querySelectorAll('[data-k7-faq]').forEach((faq) => {
    if (faq.dataset.k7Init === 'true') return;
    faq.dataset.k7Init = 'true';

    const tabs = faq.querySelectorAll('[data-k7-faq-tab]');
    const panels = faq.querySelectorAll('[data-k7-faq-panel]');
    if (!tabs.length || !panels.length) return;

    const activate = (id) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.k7FaqTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.k7FaqPanel === id;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.k7FaqTab));
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initK7Faq());
document.addEventListener('shopify:section:load', (event) => {
  initK7Faq(event.target);
});


/* k7-sparset-builder start */

function getCartDrawerSectionId(cartDrawer) {
  if (!cartDrawer) return null;

  const section = cartDrawer.closest('.shopify-section');
  if (section?.id?.startsWith('shopify-section-')) {
    return section.id.replace('shopify-section-', '');
  }

  return cartDrawer.getAttribute('data-section-id') || 'cart-drawer';
}

async function fetchCartDrawerSectionMarkup(sectionId) {
  const response = await fetch(`${window.Shopify.routes.root}?section_id=${encodeURIComponent(sectionId)}`);
  if (!response.ok) {
    throw new Error('Failed to fetch cart drawer section');
  }

  const html = await response.text();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const cartDrawer = tempDiv.querySelector('#cart-drawer, cart-drawer');
  return cartDrawer ? cartDrawer.outerHTML : html;
}

async function attachCartDrawerSections(cartContent, cartDrawer) {
  if (!cartDrawer || !cartContent) return cartContent;

  const sectionId = getCartDrawerSectionId(cartDrawer);
  if (!sectionId) return cartContent;

  if (!cartContent.sections) cartContent.sections = {};
  cartContent.sections[sectionId] = await fetchCartDrawerSectionMarkup(sectionId);
  return cartContent;
}

function initK7SparsetBuilder(root) {
  if (!root || root._k7SparsetInitialized) return;

  const configScript = root.querySelector('[data-sparset-config]');
  if (!configScript) return;

  let config = {};
  try {
    config = JSON.parse(configScript.textContent);
  } catch (error) {
    console.error('Failed to parse sparset config:', error);
    return;
  }

  const productsById = {};
  const variantsById = {};

  (config.products || []).forEach((product) => {
    productsById[String(product.id)] = product;

    const variantList = Array.isArray(product.variants) && product.variants.length
      ? product.variants
      : [{
          id: product.variantId,
          title: product.hasOnlyDefaultVariant ? 'Default Title' : product.title,
          options: [],
          price: product.price,
          compareAtPrice: product.compareAtPrice,
          available: product.available,
          image: product.image,
          volume: product.volume
        }];

    variantList.forEach((variant) => {
      variantsById[String(variant.id)] = {
        id: variant.id,
        productId: product.id,
        productTitle: product.title,
        title: variant.title,
        options: variant.options || [],
        price: variant.price,
        compareAtPrice: variant.compareAtPrice || 0,
        available: variant.available,
        image: variant.image || product.image || '',
        badge: product.badge,
        badgeColor: product.badgeColor,
        hasOnlyDefaultVariant: product.hasOnlyDefaultVariant !== false,
        volume: Number(variant.volume ?? product.volume) || 0
      };
    });
  });

  if (config.cartonVariantId && !variantsById[String(config.cartonVariantId)]) {
    variantsById[String(config.cartonVariantId)] = {
      id: config.cartonVariantId,
      productId: config.cartonProductId,
      productTitle: config.cartonTitle || 'Geschenkverpackung',
      title: config.cartonTitle || 'Geschenkverpackung',
      options: [],
      price: Number(config.cartonPrice) || 0,
      compareAtPrice: 0,
      available: true,
      image: config.cartonImage || '',
      hasOnlyDefaultVariant: true,
      volume: 0
    };
  }

  function getVariantEntry(variantId) {
    return variantsById[String(variantId)] || null;
  }

  function getVariantDisplayTitle(variantEntry) {
    if (!variantEntry) return '';
    const productTitle = (variantEntry.productTitle || '').trim();
    const variantTitle = (variantEntry.title || '').trim();
    if (variantEntry.hasOnlyDefaultVariant || !variantTitle || variantTitle === 'Default Title' || variantTitle === productTitle) {
      return productTitle;
    }
    return `${productTitle} – ${variantTitle}`;
  }

  function ensureVariantEntryFromCard(card, variantId) {
    const existing = getVariantEntry(variantId);
    if (existing) return existing;
    if (!card || !variantId) return null;

    const productId = card.getAttribute('data-product-id');
    const product = productsById[String(productId)] || {};
    const entry = {
      id: variantId,
      productId,
      productTitle: product.title
        || card.querySelector('.product-card__title')?.textContent?.trim()
        || card.querySelector('.k7-sparset-builder__card-title')?.textContent?.trim()
        || '',
      title: product.title || '',
      options: [],
      price: parseInt(card.getAttribute('data-base-price') || product.price || '0', 10) || 0,
      compareAtPrice: parseInt(card.getAttribute('data-compare-at-price') || product.compareAtPrice || '0', 10) || 0,
      available: card.getAttribute('data-available') === 'true',
      image: product.image || '',
      badge: product.badge,
      badgeColor: product.badgeColor,
      hasOnlyDefaultVariant: Boolean(product.hasOnlyDefaultVariant),
      volume: Number(card.getAttribute('data-volume') || product.volume) || 0
    };

    variantsById[String(variantId)] = entry;
    return entry;
  }

  const goals = (config.goals || []).slice().sort((a, b) => {
    const aKey = a.threshold || a.quantity || 0;
    const bKey = b.threshold || b.quantity || 0;
    return aKey - bKey;
  });
  const selectedVariantIds = [];

  let slotVariantIds = [];
  const emptySlotIconHtml = root.querySelector('.k7-sparset-builder__slot:not([data-free-product-slot]) .k7-sparset-builder__slot-icon')?.innerHTML || '';
  const initialSelectableCount = root.querySelectorAll('.k7-sparset-builder__slot:not([data-free-product-slot])').length || 12;

  function getSlotElements() {
    return root.querySelectorAll('.k7-sparset-builder__slot');
  }

  function reindexSlots() {
    getSlotElements().forEach((slot, index) => {
      slot.setAttribute('data-slot-index', String(index));
    });
  }

  function ensureSelectableSlots(minCount) {
    const container = root.querySelector('[data-sparset-slots]');
    if (!container) return;

    while (slotVariantIds.length < minCount) {
      slotVariantIds.push(null);
    }

    const template = container.querySelector('.k7-sparset-builder__slot:not([data-free-product-slot])');
    if (!template) return;

    let selectableCount = container.querySelectorAll('.k7-sparset-builder__slot:not([data-free-product-slot])').length;
    while (selectableCount < minCount) {
      const clone = template.cloneNode(true);
      clone.classList.remove('is-filled', 'is-free-product');
      clone.removeAttribute('data-free-product-slot');
      clone.removeAttribute('data-remove-storage-index');
      clone.hidden = false;
      const titleEl = clone.querySelector('[data-slot-title]');
      const subtitleEl = clone.querySelector('[data-slot-subtitle]');
      const qtyEl = clone.querySelector('[data-slot-qty]');
      const iconEl = clone.querySelector('.k7-sparset-builder__slot-icon');
      const removeBtn = clone.querySelector('[data-action="remove-slot"]');
      if (titleEl) titleEl.textContent = config.emptySlotText || 'Wähle ein Produkt';
      if (subtitleEl) subtitleEl.replaceChildren();
      if (qtyEl) {
        qtyEl.hidden = true;
        qtyEl.textContent = '';
      }
      if (iconEl) iconEl.innerHTML = emptySlotIconHtml;
      if (removeBtn) removeBtn.hidden = true;
      container.appendChild(clone);
      selectableCount += 1;
    }

    reindexSlots();
  }

  function trimExtraSlots() {
    const container = root.querySelector('[data-sparset-slots]');
    const filled = slotVariantIds.filter(Boolean);
    const target = Math.max(initialSelectableCount, filled.length);
    slotVariantIds = Array.from({ length: target }, (_, index) => filled[index] || null);

    if (!container) return;

    const nodes = Array.from(container.querySelectorAll('.k7-sparset-builder__slot:not([data-free-product-slot])'));
    while (nodes.length > target) {
      nodes.pop().remove();
    }

    reindexSlots();
  }

  function initSlotVariantIds() {
    slotVariantIds = Array.from({ length: initialSelectableCount }, () => null);
  }

  function syncSelectedVariantIdsFromSlots() {
    selectedVariantIds.length = 0;
    slotVariantIds.forEach((variantId) => {
      if (variantId) selectedVariantIds.push(variantId);
    });
  }

  function getFilledSlotCount() {
    return slotVariantIds.filter(Boolean).length;
  }

  const NEXT_CARTON_WORDS = {
    2: 'zweiten',
    3: 'dritten',
    4: 'vierten',
    5: 'fünften',
    6: 'sechsten',
    7: 'siebten',
    8: 'achten',
    9: 'neunten',
    10: 'zehnten'
  };
  let lastFullCartons = 0;

  function getVariantVolume(variantId) {
    const entry = getVariantEntry(variantId);
    if (!entry) return 0;

    const volume = Number(entry.volume);
    if (Number.isFinite(volume) && volume > 0) return volume;

    const product = productsById[String(entry.productId)];
    const productVolume = Number(product?.volume);
    return Number.isFinite(productVolume) ? productVolume : 0;
  }

  let cartonWanted = false;

  function getTotalVolume() {
    const cartonProductId = config.cartonProductId ? String(config.cartonProductId) : '';
    return slotVariantIds.reduce((sum, variantId) => {
      if (!variantId) return sum;
      const entry = getVariantEntry(variantId);
      if (cartonProductId && entry && String(entry.productId) === cartonProductId) return sum;
      return sum + getVariantVolume(variantId);
    }, 0);
  }

  function getCartonQuantity() {
    if (!cartonWanted || !config.cartonVariantId) return 0;
    const limit = Number(config.cartonVolumeLimit) || 100;
    const volume = getTotalVolume();
    if (limit <= 0 || volume <= 0) return 1;
    return Math.max(1, Math.ceil(volume / limit));
  }

  function getCartonTotal() {
    if (config.cartonAsGoodie) return 0;
    return getCartonQuantity() * (Number(config.cartonPrice) || 0);
  }

  function getCartonNoticeText(fullCartons) {
    const template = config.cartonNoticeText
      || 'Wenn du die Produkte in einen Geschenkkarton verpacken möchtest, hast du jetzt das Limit von Karton [carton] erreicht, du brauchst einen [next] Karton.';
    const nextWord = NEXT_CARTON_WORDS[fullCartons + 1] || `${fullCartons + 1}.`;
    return template
      .split('[carton]').join(String(fullCartons))
      .split('[next]').join(nextWord);
  }

  function updateCartonNotice() {
    if (!cartonNoticeEl) return;

    const cartonQty = getCartonQuantity();
    const fullCartons = cartonQty > 1 ? cartonQty - 1 : 0;
    const shouldShow = cartonWanted && fullCartons >= 1;
    const cartonQtyEl = root.querySelector('[data-sparset-carton-qty]');
    if (cartonQtyEl) {
      cartonQtyEl.hidden = cartonQty < 2;
      cartonQtyEl.textContent = cartonQty > 1 ? ` · ${cartonQty}×` : '';
    }

    if (shouldShow) {
      cartonNoticeEl.textContent = getCartonNoticeText(fullCartons);
      cartonNoticeEl.hidden = false;

      if (fullCartons > lastFullCartons && panel) {
        panel.setAttribute('data-expanded', 'true');
        const toggleBtn = root.querySelector('[data-action="toggle-panel"]');
        toggleBtn?.setAttribute('aria-expanded', 'true');
        syncAtcMode(getFilledSlotCount());
      }

      lastFullCartons = fullCartons;
      return;
    }

    cartonNoticeEl.textContent = '';
    cartonNoticeEl.hidden = true;
    lastFullCartons = 0;
  }

  function updateCartonFill() {
    const wrap = root.querySelector('[data-sparset-carton-fill]');
    if (!wrap) return;

    const bar = wrap.querySelector('[data-sparset-carton-fill-bar]');
    const track = wrap.querySelector('[data-sparset-carton-fill-track]');
    const label = wrap.querySelector('[data-sparset-carton-fill-label]');

    if (!cartonWanted) {
      wrap.hidden = true;
      return;
    }

    const limit = Number(config.cartonVolumeLimit) || 100;
    const volume = getTotalVolume();
    const cartonQty = Math.max(getCartonQuantity(), 1);
    let fill = 0;

    if (limit > 0 && volume > 0) {
      const remainder = volume % limit;
      fill = remainder === 0 ? 100 : Math.min(100, (remainder / limit) * 100);
    }

    const percent = Math.round(fill);
    wrap.hidden = false;
    if (bar) bar.style.width = `${percent}%`;
    if (track) track.setAttribute('aria-valuenow', String(percent));
    if (label) {
      label.textContent = cartonQty > 1
        ? `Karton ${cartonQty} ist zu ${percent}% voll`
        : `Deine Box ist zu ${percent}% voll`;
    }
  }

  function updateCartonFitNotice() {
    const notice = root.querySelector('[data-sparset-carton-fit-notice]');
    if (!notice) return;

    if (!cartonWanted) {
      notice.textContent = '';
      notice.hidden = true;
      return;
    }

    const subtotal = getGoalSubtotal();
    const names = [];
    goals.forEach((goal) => {
      if (goal.reward !== 'goodie' || goal.fitsCarton !== false) return;
      if (subtotal < goal.threshold) return;
      const name = goal.subtitle || goal.title;
      if (name) names.push(name);
    });

    if (!names.length) {
      notice.textContent = '';
      notice.hidden = true;
      return;
    }

    notice.textContent = names.map((name) => `${name} passt nicht in die Geschenkverpackung.`).join(' ');
    notice.hidden = false;
  }

  function syncSlots() {}

  const referralInput = root.querySelector('[data-sparset-referral-input]');
  let referralCodeValue = '';
  let resolvedPreviewDiscount = {
    type: null,
    value: 0,
    code: null,
    loaded: false
  };
  let previewDiscountRetried = false;
  const panel = root.querySelector('.k7-sparset-builder__panel');
  const countEls = root.querySelectorAll('[data-sparset-count]');
  const goalsFill = root.querySelector('[data-goals-fill]');
  const goalNodes = root.querySelectorAll('.k7-sparset-builder__goal-node');
  const goalListItems = root.querySelectorAll('[data-goal-list-item]');
  const atcButton = root.querySelector('[data-action="add-to-cart"]');

  function isMobilePanelCollapsed() {
    return window.matchMedia('(max-width: 999px)').matches && panel?.getAttribute('data-expanded') !== 'true';
  }

  function syncAtcMode(count) {
    if (!atcButton) return;
    atcButton.disabled = isMobilePanelCollapsed() ? false : count < minProducts;
  }
  const savingsRow = root.querySelector('[data-sparset-savings]');
  const savingsAmountEl = root.querySelector('[data-sparset-savings-amount]');
  const totalRow = root.querySelector('[data-sparset-total]');
  const totalPriceEl = root.querySelector('[data-sparset-total-price]');
  const totalCompareEl = root.querySelector('[data-sparset-total-compare]');
  const discountAppliedRow = root.querySelector('[data-sparset-discount-applied]');
  const discountLabelEl = root.querySelector('[data-sparset-discount-label]');
  const discountAmountEl = root.querySelector('[data-sparset-discount-amount]');
  const cartonNoticeEl = root.querySelector('[data-sparset-carton-notice]');
  const cartonToggle = root.querySelector('[data-sparset-carton-toggle]');
  const cartonDialog = root.querySelector('[data-sparset-carton-dialog]');
  const goalsDetailsBtn = root.querySelector('[data-sparset-goals-details]');
  const goalsWrap = root.querySelector('.k7-sparset-builder__goals');
  goalsDetailsBtn?.addEventListener('click', () => {
    const open = goalsWrap?.classList.toggle('is-open');
    goalsDetailsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const label = goalsDetailsBtn.querySelector('[data-goals-details-label]');
    if (label) label.textContent = open ? 'Vorteile ausblenden' : 'Vorteile ansehen';
    if (open) {
      goalsWrap?.querySelector('.k7-sparset-builder__goal-list')?.scrollIntoView({ block: 'nearest' });
    }
  });
  const goalDialog = root.querySelector('[data-sparset-goal-dialog]');
  const goalDialogImage = goalDialog?.querySelector('[data-sparset-goal-dialog-image]');
  const goalDialogTitle = goalDialog?.querySelector('[data-sparset-goal-dialog-title]');
  root.querySelectorAll('[data-sparset-goal-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!goalDialog || !goalDialogImage) return;
      const image = button.getAttribute('data-image') || '';
      const title = button.getAttribute('data-title') || '';
      goalDialogImage.src = image;
      goalDialogImage.alt = title;
      if (goalDialogTitle) goalDialogTitle.textContent = title;
      if (goalDialog.parentElement !== document.body) document.body.appendChild(goalDialog);
      goalDialog.showModal();
    });
  });
  goalDialog?.querySelector('[data-sparset-goal-dialog-close]')?.addEventListener('click', () => {
    goalDialog.close();
  });
  goalDialog?.addEventListener('click', (event) => {
    if (event.target === goalDialog) goalDialog.close();
  });
  let rewardConfettiFrame = 0;
  let rewardConfettiRun = 0;
  const seenReachedGoals = new Set();
  const rewardConfetti = root.querySelector('[data-sparset-reward-confetti]');
  cartonToggle?.addEventListener('change', () => {
    cartonWanted = Boolean(cartonToggle.checked);
    updateUI();
  });
  root.querySelector('[data-sparset-carton-info]')?.addEventListener('click', () => {
    cartonDialog?.showModal();
  });
  cartonDialog?.querySelector('[data-sparset-carton-dialog-close]')?.addEventListener('click', () => {
    cartonDialog.close();
  });
  cartonDialog?.addEventListener('click', (event) => {
    if (event.target === cartonDialog) cartonDialog.close();
  });
  const searchInput = root.querySelector('[data-sparset-search]');
  const searchWrap = root.querySelector('[data-sparset-search-wrap]');
  const searchToggle = root.querySelector('[data-sparset-search-toggle]');
  const searchEmptyEl = root.querySelector('[data-sparset-search-empty]');
  const filterButtons = root.querySelectorAll('[data-sparset-filter]');
  const productList = root.querySelector('.k7-sparset-builder__grid');
  const defaultCardOrder = [...getProductCards()];
  const collectionOrders = config.collectionOrders || {};
  const minProducts = parseInt(root.getAttribute('data-min-products') || config.minProducts || 2, 10);
  const showReferralCode = Boolean(config.showReferralCode);
  function hasFreeProductSlot() {
    return Boolean(config.freeProduct?.title);
  }

  function getSelectedIndexForSlot(slotIndex) {
    return hasFreeProductSlot() ? slotIndex - 1 : slotIndex;
  }

  function renderFreeProductSlot(slot) {
    const freeProduct = config.freeProduct;
    const titleEl = slot.querySelector('[data-slot-title]');
    const subtitleEl = slot.querySelector('[data-slot-subtitle]');
    const iconEl = slot.querySelector('.k7-sparset-builder__slot-icon');
    const removeBtn = slot.querySelector('[data-action="remove-slot"]');
    const badgeText = freeProduct.badge || 'GRATIS';

    slot.classList.add('is-filled', 'is-free-product');
    if (titleEl) titleEl.textContent = freeProduct.title;
    if (subtitleEl) {
      subtitleEl.innerHTML = `<span class="badge k7-sparset-builder__slot-gratis-badge">${badgeText}</span>`;
    }
    if (iconEl) {
      iconEl.innerHTML = freeProduct.image
        ? `<img src="${freeProduct.image}" alt="${freeProduct.title.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
        : '';
    }
    if (removeBtn) removeBtn.hidden = true;
  }

  function formatSparsetMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }

    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `€${amount}`;
  }

  function goalUsesPrice(goal) {
    return goal.reward === 'goodie' || goal.reward === 'shipping' || (goal.reward === 'percent' && goal.threshold >= 100);
  }

  function goalsUsePrice() {
    return goals.some(goalUsesPrice);
  }

  function getPaidSubtotal() {
    let subtotal = 0;
    selectedVariantIds.forEach((variantId) => {
      const product = getVariantEntry(variantId);
      if (product) subtotal += product.price;
    });
    return subtotal;
  }

  function getGoalSubtotal() {
    return getPaidSubtotal() + getCartonTotal();
  }

  function getCurrentDiscount(count) {
    let current = null;
    goals.forEach((goal) => {
      if (goal.reward === 'goodie') return;
      if (count >= goal.quantity) {
        current = goal;
      }
    });
    return current;
  }

  function getDiscountPercent(count) {
    if (goalsUsePrice()) {
      const subtotal = getGoalSubtotal();
      let current = 0;
      goals.forEach((goal) => {
        if (!goalUsesPrice(goal) || goal.reward !== 'percent') return;
        if (subtotal >= goal.threshold && goal.discount > current) current = goal.discount;
      });
      return current;
    }

    const currentDiscount = getCurrentDiscount(count);
    return currentDiscount ? currentDiscount.discount : 0;
  }

  function getPreviewDiscountFallbackPercent() {
    return parseInt(config.previewDiscountPercent, 10) || 0;
  }

  function getPreviewDiscountPercent() {
    if (!resolvedPreviewDiscount.loaded) {
      return getPreviewDiscountFallbackPercent();
    }

    if (resolvedPreviewDiscount.type === 'percentage') {
      return resolvedPreviewDiscount.value || 0;
    }

    return getPreviewDiscountFallbackPercent();
  }

  function getPreviewDiscountBadgeText() {
    const previewPercent = getPreviewDiscountPercent();

    if (resolvedPreviewDiscount.code && resolvedPreviewDiscount.type === 'fixed') {
      return `-${formatSparsetMoney(Math.round(resolvedPreviewDiscount.value * 100))}`;
    }

    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function combineDiscountPercents(goalPercent, previewPercent) {
    const goal = parseFloat(goalPercent) || 0;
    const preview = parseFloat(previewPercent) || 0;

    if (goal <= 0 && preview <= 0) return 0;
    if (goal <= 0) return Math.round(preview);
    if (preview <= 0) return Math.round(goal);

    return Math.round(100 - ((100 - goal) * (100 - preview) / 100));
  }

  function getCombinedDiscountPercent(goalPercent) {
    return combineDiscountPercents(goalPercent, getPreviewDiscountPercent());
  }

  function getDisplayDiscountPercent(count) {
    return getCombinedDiscountPercent(getDiscountPercent(count));
  }

  function getTierPercentForNextPlaceholder() {
    const count = selectedVariantIds.length;
    const slotList = Array.from(getSlotElements());

    for (let slotIndex = 0; slotIndex < slotList.length; slotIndex += 1) {
      const slot = slotList[slotIndex];
      if (slot.hasAttribute('data-free-product-slot')) continue;

      const selectedIndex = getSelectedIndexForSlot(slotIndex);
      const hasProduct = selectedIndex >= 0 && slotVariantIds[selectedIndex];

      if (!hasProduct) {
        const productCountAfterFill = Math.max(1, getFilledSlotCount() + 1);
        return getDiscountPercent(productCountAfterFill);
      }
    }

    return getDiscountPercent(count + 1);
  }

  function getReferenceUnitPrice(basePriceCents, compareAtCents) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;

    if (config.showVariantCompareAt && compareAt > basePrice) {
      return compareAt;
    }

    return basePrice;
  }

  function applyPercentOffNearest(amountCents, discountPercent) {
    const amount = parseInt(amountCents, 10) || 0;
    const discount = parseFloat(discountPercent) || 0;

    if (!discount || discount <= 0 || amount <= 0) return amount;
    if (discount >= 100) return 0;

    return Math.round(amount * (100 - discount) / 100);
  }

  function applyUnitDiscountTruncated(basePriceCents, discountPercent) {
    return applyPercentOffNearest(basePriceCents, discountPercent);
  }

  function getDiscountedUnitPriceStacked(basePriceCents, goalPercent, previewPercent) {
    const afterGoal = applyUnitDiscountTruncated(basePriceCents, goalPercent);
    return applyUnitDiscountTruncated(afterGoal, previewPercent);
  }

  function getProductBadgePercent(basePriceCents, compareAtCents, tierGoalPercent) {
    const tierGoal = parseFloat(tierGoalPercent) || 0;
    const previewPercent = getPreviewDiscountPercent();

    if (tierGoal <= 0 && previewPercent <= 0) {
      return 0;
    }

    const referencePrice = getReferenceUnitPrice(basePriceCents, compareAtCents);
    const salePrice = getDiscountedUnitPriceStacked(basePriceCents, tierGoal, previewPercent);

    if (referencePrice <= 0 || salePrice >= referencePrice) {
      return getCombinedDiscountPercent(tierGoal);
    }

    return Math.round((referencePrice - salePrice) / referencePrice * 100);
  }

  async function resolvePreviewDiscountCode() {
    const code = (config.previewDiscountCode || '').trim();
    const fallbackPercent = getPreviewDiscountFallbackPercent();

    if (!code) {
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
      return;
    }

    try {
      const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
      const existingApps = cartBefore.cart_level_discount_applications || [];
      const existingCode = existingApps[0]?.title || '';
      const hadDiscount = existingApps.length > 0;
      const alreadyApplied = hadDiscount && existingCode.toLowerCase() === code.toLowerCase();

      if (alreadyApplied) {
        const app = existingApps[0];
        if (app.value_type === 'percentage') {
          resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
        } else if (app.value_type === 'fixed_amount') {
          resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
        } else {
          resolvedPreviewDiscount = { type: fallbackPercent > 0 ? 'percentage' : null, value: fallbackPercent, code: null, loaded: true };
        }
        return;
      }

      const cartAfter = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then((response) => response.json());

      const codeEntry = (cartAfter.discount_codes || []).find((entry) =>
        String(entry.code || '').toLowerCase() === code.toLowerCase()
      );

      const needsRestore = !hadDiscount || existingCode.toLowerCase() !== code.toLowerCase();

      if (!codeEntry?.applicable) {
        if (needsRestore) {
          await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
          });
        }

        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
        return;
      }

      const app = (cartAfter.cart_level_discount_applications || []).find((entry) =>
        String(entry.title || '').toLowerCase() === code.toLowerCase()
      ) || cartAfter.cart_level_discount_applications?.[0];

      if (app?.value_type === 'percentage') {
        resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
      } else if (app?.value_type === 'fixed_amount') {
        resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
      } else {
        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
      }

      if (needsRestore) {
        const restoredCart = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
        }).then((response) => response.json());

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'sparset:discount-preview',
            cart: restoredCart
          }
        }));
      }
    } catch (error) {
      console.error('Failed to resolve preview discount code:', error);
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
    }
  }

  function maybeRetryPreviewDiscount(count) {
    const code = (config.previewDiscountCode || '').trim();
    if (!code || previewDiscountRetried || count < minProducts) return;
    if (resolvedPreviewDiscount.code) return;

    previewDiscountRetried = true;
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  function getPreviewDiscountSavings(count) {
    if (!count || selectedVariantIds.length === 0) return 0;

    const goalPercent = getDiscountPercent(count);
    let afterGoalTotal = 0;
    let afterPreviewTotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = getVariantEntry(variantId);
      if (!product) return;

      const afterGoal = getDiscountedUnitPriceStacked(product.price, goalPercent, 0);
      const afterPreview = getDiscountedUnitPriceStacked(product.price, goalPercent, getPreviewDiscountPercent());
      afterGoalTotal += afterGoal;
      afterPreviewTotal += afterPreview;
    });

    if (!afterGoalTotal) return 0;

    if (resolvedPreviewDiscount.type === 'fixed' && resolvedPreviewDiscount.value > 0) {
      return Math.min(afterGoalTotal, Math.round(resolvedPreviewDiscount.value * 100));
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return afterGoalTotal - afterPreviewTotal;
    }

    return 0;
  }

  function getPreviewDiscountLabel() {
    if (resolvedPreviewDiscount.code) {
      return resolvedPreviewDiscount.code;
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function hasActivePreviewDiscount() {
    if (!resolvedPreviewDiscount.loaded) return false;
    if (resolvedPreviewDiscount.code) return true;
    return getPreviewDiscountPercent() > 0;
  }

  function updatePreviewDiscountRow(count, totals) {
    if (!discountAppliedRow || !discountLabelEl || !discountAmountEl) return;

    if (!hasActivePreviewDiscount()) {
      discountAppliedRow.hidden = true;
      return;
    }

    const label = getPreviewDiscountLabel();
    if (!label) {
      discountAppliedRow.hidden = true;
      return;
    }

    discountAppliedRow.hidden = false;
    discountLabelEl.textContent = label;

    const previewPercent = getPreviewDiscountPercent();
    if (!resolvedPreviewDiscount.code && previewPercent > 0) {
      discountAmountEl.textContent = '';
      discountAmountEl.hidden = true;
      return;
    }

    if (count > 0 && totals.originalTotal > 0) {
      if (previewPercent > 0) {
        discountAmountEl.textContent = `-${previewPercent}%`;
        discountAmountEl.hidden = false;
        return;
      }

      const savings = getPreviewDiscountSavings(count);
      if (savings > 0) {
        const base = totals.discountedTotal + savings;
        const savingsPercent = base > 0 ? Math.round((savings * 100) / base) : 0;
        if (savingsPercent > 0) {
          discountAmountEl.textContent = `-${savingsPercent}%`;
          discountAmountEl.hidden = false;
          return;
        }
      }
    }

    discountAmountEl.textContent = '';
    discountAmountEl.hidden = true;
  }

  function renderPriceMarkup(basePriceCents, goalPercent, compareAtCents, includePreview) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;
    const showCompareAt = config.showVariantCompareAt && compareAt > basePrice;
    const previewPercent = includePreview === false ? 0 : getPreviewDiscountPercent();
    const salePrice = getDiscountedUnitPriceStacked(basePrice, goalPercent, previewPercent);
    const referencePrice = getReferenceUnitPrice(basePrice, compareAt);

    if (showCompareAt) {
      if (salePrice >= referencePrice) {
        return `<price-list class="price-list justify-center"><sale-price>${formatSparsetMoney(basePrice)}</sale-price></price-list>`;
      }

      return `<price-list class="price-list justify-center"><sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(referencePrice)}</compare-at-price></price-list>`;
    }

    if ((!goalPercent && !previewPercent) || salePrice >= basePrice) {
      return `<price-list class="price-list justify-center"><sale-price>${formatSparsetMoney(basePrice)}</sale-price></price-list>`;
    }

    return `<price-list class="price-list justify-center"><sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(basePrice)}</compare-at-price></price-list>`;
  }

  function getSelectionTotals(count) {
    const goalPercent = getDiscountPercent(count);
    let priceSubtotal = 0;
    let compareSubtotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = getVariantEntry(variantId);
      if (!product) return;

      priceSubtotal += product.price;
      compareSubtotal += getReferenceUnitPrice(product.price, product.compareAtPrice);
    });

    const discountedTotal = applyPercentOffNearest(priceSubtotal, goalPercent);
    const discountAmount = priceSubtotal - discountedTotal;
    const originalTotal = priceSubtotal;
    const savings = (config.showVariantCompareAt && compareSubtotal > priceSubtotal)
      ? compareSubtotal - discountedTotal
      : priceSubtotal - discountedTotal;

    return {
      priceSubtotal,
      compareSubtotal,
      originalTotal,
      discountedTotal,
      savings
    };
  }

  function getGoodieOriginalPrice(priceCents, compareAtCents) {
    const price = parseInt(priceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;
    return compareAt > price ? compareAt : price;
  }

  function getUnlockedGoodieSavings() {
    const subtotal = getGoalSubtotal();
    const selected = new Set(selectedVariantIds.filter(Boolean).map((id) => String(id)));
    let savings = 0;

    goals.forEach((goal) => {
      if (goal.reward !== 'goodie') return;

      const threshold = Number(goal.threshold) || 0;
      const reached = threshold === 0 ? subtotal > 0 : subtotal >= threshold;
      if (!reached) return;

      [
        { id: goal.variantId, price: goal.price, compareAt: goal.compareAtPrice },
        { id: goal.variantId2, price: goal.price2, compareAt: goal.compareAtPrice2 }
      ].forEach((variant) => {
        const id = parseInt(variant.id, 10);
        if (!id || selected.has(String(id))) return;
        savings += getGoodieOriginalPrice(variant.price, variant.compareAt);
      });
    });

    return savings;
  }

  function getGoalSubtitleForSlot(slotIndex) {
    if (goalsUsePrice()) return '';
    const goalIndex = hasFreeProductSlot() ? Math.max(0, slotIndex - 1) : slotIndex;
    if (goalIndex < goals.length) {
      return goals[goalIndex].subtitle || '';
    }
    return '';
  }

  function getFilledSlotGroups() {
    const groups = [];
    const indexByVariant = {};

    slotVariantIds.forEach((variantId, storageIndex) => {
      if (!variantId) return;

      const key = String(variantId);
      if (Object.prototype.hasOwnProperty.call(indexByVariant, key)) {
        const group = groups[indexByVariant[key]];
        group.quantity += 1;
        group.storageIndex = storageIndex;
        return;
      }

      indexByVariant[key] = groups.length;
      groups.push({
        variantId: key,
        quantity: 1,
        storageIndex
      });
    });

    return groups;
  }

  function getProductCount(productId) {
    return slotVariantIds.filter((variantId) => {
      if (!variantId) return false;
      const product = getVariantEntry(variantId);
      return product && String(product.productId) === String(productId);
    }).length;
  }

  function getSelectedVariantIdsForProduct(productId) {
    return selectedVariantIds.filter((variantId) => {
      const product = getVariantEntry(variantId);
      return product && String(product.productId) === String(productId);
    });
  }

  function setProductQuantity(variantId, productId, quantity) {
    const vid = String(variantId);

    for (let i = 0; i < slotVariantIds.length; i += 1) {
      if (slotVariantIds[i] && getVariantEntry(slotVariantIds[i])?.productId == productId) {
        slotVariantIds[i] = null;
      }
    }

    const otherCount = slotVariantIds.filter((id) => {
      if (!id) return false;
      const product = getVariantEntry(id);
      return !product || String(product.productId) !== String(productId);
    }).length;

    const clampedQty = Math.max(0, quantity);
    ensureSelectableSlots(otherCount + clampedQty);

    let added = 0;
    for (let i = 0; i < slotVariantIds.length && added < clampedQty; i += 1) {
      if (!slotVariantIds[i]) {
        slotVariantIds[i] = vid;
        added += 1;
      }
    }

    syncSelectedVariantIdsFromSlots();
    updateUI();
  }

  function bindQuantitySelector(card) {
    const selector = card.querySelector('quantity-selector');
    if (!selector || selector.dataset.sparsetBound === 'true') return;

    const productId = String(card.getAttribute('data-product-id'));
    const input = card.querySelector('[data-sparset-quantity-input]');
    const minusBtn = selector.querySelector('button:first-of-type');
    const plusBtn = selector.querySelector('button:last-of-type');

    const applyQuantity = (quantity) => {
      if (card.hasAttribute('data-sparset-carton-card')) {
        if (cartonToggle) cartonToggle.checked = quantity > 0;
        cartonWanted = quantity > 0;
        updateUI();
        return;
      }
      const maxQuantity = parseInt(card.getAttribute('data-max-quantity'), 10);
      if (Number.isFinite(maxQuantity) && maxQuantity > 0) {
        quantity = Math.min(quantity, maxQuantity);
      }
      const variantId = card.getAttribute('data-variant-id');
      setProductQuantity(variantId, productId, quantity);
    };

    const onMinus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) - 1);
    };

    const onPlus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) + 1);
    };

    const onInputChange = () => {
      applyQuantity(parseInt(input.value, 10) || 0);
    };

    minusBtn?.addEventListener('click', onMinus, true);
    plusBtn?.addEventListener('click', onPlus, true);
    input?.addEventListener('change', onInputChange);

    selector.dataset.sparsetBound = 'true';
  }

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function getProductCards() {
    return root.querySelectorAll('[data-sparset-card], .k7-sparset-builder__card');
  }

  function getActiveFilterButton() {
    return root.querySelector('[data-sparset-filter][aria-pressed="true"]');
  }

  function cardMatchesFilter(card, filterButton) {
    if (card.hasAttribute('data-sparset-filter-always')) return true;
    if (!filterButton || filterButton.getAttribute('data-filter-all') === 'true') return true;

    const filterId = String(filterButton.getAttribute('data-filter-id') || '');
    const filterKeys = String(filterButton.getAttribute('data-filter-keys') || '')
      .split(/\s+/)
      .filter(Boolean);
    const cardIds = String(card.getAttribute('data-filter-ids') || '').split(/\s+/);
    const cardKeys = String(card.getAttribute('data-filter-keys') || '').split(/\s+/);

    if (filterId && cardIds.includes(filterId)) return true;
    return filterKeys.some((key) => cardKeys.includes(key));
  }

  function setActiveFilter(button) {
    filterButtons.forEach((filterButton) => {
      filterButton.setAttribute('aria-pressed', filterButton === button ? 'true' : 'false');
    });
    filterProductCards();
  }

  function setSearchOpen(open) {
    if (!searchWrap || !searchToggle) return;
    searchWrap.classList.toggle('is-open', open);
    searchToggle.setAttribute('aria-expanded', String(open));
    const searchIcon = searchToggle.querySelector('[data-search-icon]');
    const closeIcon = searchToggle.querySelector('[data-close-icon]');
    if (searchIcon) searchIcon.hidden = open;
    if (closeIcon) closeIcon.hidden = !open;
    if (searchInput) {
      searchInput.setAttribute('tabindex', open ? '0' : '-1');
      if (open) searchInput.focus();
    }
  }

  function updateSearchToggleState() {
    if (!searchToggle || !searchInput) return;
    searchToggle.classList.toggle('has-query', Boolean(searchInput.value.trim()));
  }

  function applyCollectionOrder(filterButton) {
    if (!productList || !defaultCardOrder.length) return;

    const filterId = filterButton && filterButton.getAttribute('data-filter-all') !== 'true'
      ? String(filterButton.getAttribute('data-filter-id') || '')
      : '';
    const orderIds = filterId ? collectionOrders[filterId] : null;

    if (!Array.isArray(orderIds) || !orderIds.length) {
      defaultCardOrder.forEach((card) => productList.appendChild(card));
      return;
    }

    const rank = new Map(orderIds.map((id, index) => [String(id), index]));
    const pinned = [];
    const ordered = [];

    defaultCardOrder.forEach((card) => {
      if (card.hasAttribute('data-sparset-filter-always') || card.hasAttribute('data-sparset-carton-card')) {
        pinned.push(card);
        return;
      }
      ordered.push(card);
    });

    ordered.sort((a, b) => {
      const aId = String(a.getAttribute('data-product-id') || '');
      const bId = String(b.getAttribute('data-product-id') || '');
      const aRank = rank.has(aId) ? rank.get(aId) : Number.MAX_SAFE_INTEGER;
      const bRank = rank.has(bId) ? rank.get(bId) : Number.MAX_SAFE_INTEGER;
      return aRank - bRank;
    });

    [...pinned, ...ordered].forEach((card) => productList.appendChild(card));
  }

  function filterProductCards() {
    const query = searchInput ? normalizeSearchValue(searchInput.value) : '';
    const activeFilter = getActiveFilterButton();
    const hasActiveFilter = Boolean(activeFilter && activeFilter.getAttribute('data-filter-all') !== 'true');
    applyCollectionOrder(activeFilter);
    let visibleCount = 0;

    getProductCards().forEach((card) => {
      const title = normalizeSearchValue(
        card.getAttribute('data-search-title')
          || card.querySelector('.product-card__title')?.textContent
          || card.querySelector('.k7-sparset-builder__card-title')?.textContent
          || ''
      );
      const isCartonCard = card.hasAttribute('data-sparset-carton-card');
      const matchesSearch = isCartonCard || !query || title.includes(query);
      const matchesFilter = cardMatchesFilter(card, activeFilter);
      const matches = matchesSearch && matchesFilter;
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (searchEmptyEl) {
      searchEmptyEl.hidden = visibleCount > 0 || (!query && !hasActiveFilter);
    }

    updateSearchToggleState();
  }

  function updateProductCards() {
    const atMax = false;
    const cardTierPercent = getTierPercentForNextPlaceholder();

    root.querySelectorAll('[data-sparset-card], .k7-sparset-builder__card').forEach((card) => {
      if (card.hasAttribute('data-sparset-carton-card')) {
        const addButton = card.querySelector('[data-action="add-product"]');
        const quantityWrap = card.querySelector('[data-sparset-quantity-wrap]');
        const quantityInput = card.querySelector('[data-sparset-quantity-input]');
        const isAvailable = card.getAttribute('data-available') === 'true';
        card.classList.toggle('is-selected', cartonWanted);
        card.classList.toggle('is-unavailable', !isAvailable);
        card.classList.toggle('is-addable', isAvailable);
        if (cartonWanted) {
          if (addButton) addButton.hidden = true;
          if (quantityWrap) quantityWrap.hidden = false;
          if (quantityInput) {
            quantityInput.value = '1';
            quantityInput.size = 2;
          }
          bindQuantitySelector(card);
        } else {
          if (addButton) {
            addButton.hidden = false;
            addButton.disabled = !isAvailable;
          }
          if (quantityWrap) quantityWrap.hidden = true;
        }
        return;
      }

      const productId = String(card.getAttribute('data-product-id'));
      const addButton = card.querySelector('[data-action="add-product"]');
      const quantityWrap = card.querySelector('[data-sparset-quantity-wrap]');
      const quantityInput = card.querySelector('[data-sparset-quantity-input]');
      const priceEl = card.querySelector('[data-card-price]');
      const discountBadgeWrap = card.querySelector('[data-card-discount-badge-wrap]');
      const discountBadge = card.querySelector('[data-card-discount-badge]');
      const productCount = getProductCount(productId);
      const selectedForProduct = getSelectedVariantIdsForProduct(productId);
      const uniqueVariantIds = [...new Set(selectedForProduct)];
      const activeVariantId = uniqueVariantIds.length === 1
        ? uniqueVariantIds[0]
        : (card.getAttribute('data-variant-id') || productsById[productId]?.variantId);
      const activeVariant = getVariantEntry(activeVariantId);
      const basePrice = parseInt(
        activeVariant?.price
          || card.getAttribute('data-base-price')
          || priceEl?.getAttribute('data-base-price')
          || '0',
        10
      );
      const compareAtPrice = parseInt(
        activeVariant?.compareAtPrice
          || card.getAttribute('data-compare-at-price')
          || '0',
        10
      );
      const badgePercent = getProductBadgePercent(basePrice, compareAtPrice, cardTierPercent);
      const isAvailable = card.getAttribute('data-available') === 'true';

      if (activeVariantId) {
        card.setAttribute('data-variant-id', String(activeVariantId));
        card.setAttribute('data-base-price', String(basePrice));
        card.setAttribute('data-compare-at-price', String(compareAtPrice));
      }

      card.classList.toggle('is-selected', productCount > 0);
      card.classList.toggle('is-unavailable', !isAvailable);
      card.classList.toggle('is-addable', isAvailable && !atMax);

      if (priceEl && basePrice > 0) {
        priceEl.innerHTML = renderPriceMarkup(basePrice, cardTierPercent, compareAtPrice);
      }

      if (discountBadgeWrap && discountBadge) {
        if (badgePercent > 0) {
          discountBadge.textContent = `-${badgePercent}%`;
          discountBadgeWrap.hidden = false;
        } else {
          discountBadge.textContent = '';
          discountBadgeWrap.hidden = true;
        }
      }

      if (productCount > 0) {
        if (addButton) addButton.hidden = true;
        if (quantityWrap) quantityWrap.hidden = false;
        if (quantityInput) {
          quantityInput.value = String(productCount);
          quantityInput.size = Math.max(String(productCount).length + 1, 2);
        }
        const maxQuantity = parseInt(card.getAttribute('data-max-quantity'), 10);
        const plusBtn = quantityWrap?.querySelector('button:last-of-type');
        if (plusBtn) {
          plusBtn.disabled = Number.isFinite(maxQuantity) && maxQuantity > 0 && productCount >= maxQuantity;
        }
        bindQuantitySelector(card);
      } else {
        if (addButton) {
          addButton.hidden = false;
          addButton.disabled = atMax || !isAvailable;
          addButton.classList.toggle('button--subdued', !isAvailable || atMax);
        }
        if (quantityWrap) quantityWrap.hidden = true;
      }
    });

  }

  function adjustGoalNodePositions() {
    const track = root.querySelector('.k7-sparset-builder__goals-track');
    if (!track || !goalNodes.length) return;

    const inset = 8;
    const minBound = inset;
    const maxBound = 100 - inset;
    const trackWidth = track.offsetWidth || 1;

    const items = Array.from(goalNodes).map((node) => ({
      node,
      ideal: parseFloat(node.getAttribute('data-goal-ideal-position') || node.getAttribute('data-goal-position') || '0'),
      quantity: parseInt(node.getAttribute('data-goal-quantity'), 10)
    })).sort((a, b) => a.ideal - b.ideal);

    const count = items.length;
    if (!count) return;

    let maxNodeWidth = 44;
    items.forEach((item) => {
      maxNodeWidth = Math.max(maxNodeWidth, item.node.offsetWidth || 0);
    });

    const minGapPercent = Math.min(16, Math.max(7, (maxNodeWidth / trackWidth) * 100 * 0.95));
    let positions = [];

    if (count === 1) {
      positions = [Math.max(minBound, Math.min(maxBound, items[0].ideal))];
    } else {
      const ideals = items.map((item) => item.ideal);
      const available = maxBound - minBound;
      const required = (count - 1) * minGapPercent;
      const extra = available - required;

      if (extra <= 0) {
        for (let i = 0; i < count; i += 1) {
          positions[i] = minBound + (i / (count - 1)) * available;
        }
      } else {
        const idealGaps = [];
        let totalIdealGap = 0;

        for (let i = 0; i < count - 1; i += 1) {
          const gap = Math.max(0, ideals[i + 1] - ideals[i]);
          idealGaps.push(gap);
          totalIdealGap += gap;
        }

        positions[0] = minBound;
        for (let i = 0; i < count - 1; i += 1) {
          const extraGap = totalIdealGap > 0 ? (idealGaps[i] / totalIdealGap) * extra : extra / (count - 1);
          positions[i + 1] = positions[i] + minGapPercent + extraGap;
        }
      }
    }

    items.forEach((item, index) => {
      const position = Math.round(positions[index] * 10) / 10;
      item.node.style.setProperty('--goal-position', `${position}%`);
      item.node.setAttribute('data-goal-position', String(position));
    });
  }

  function getGoalNodesData() {
    return Array.from(goalNodes).map((node) => ({
      quantity: parseInt(node.getAttribute('data-goal-quantity'), 10),
      position: parseFloat(node.getAttribute('data-goal-position') || node.style.getPropertyValue('--goal-position') || '0')
    })).sort((a, b) => a.quantity - b.quantity);
  }

  function getProgressPercent(count) {
    const nodes = getGoalNodesData();

    if (!nodes.length) {
      return count > 0 ? Math.min((count / Math.max(minProducts, 1)) * 100, 100) : 0;
    }

    if (count <= 0) return 0;

    const lastNode = nodes[nodes.length - 1];
    if (count >= lastNode.quantity) {
      return lastNode.position;
    }

    let prev = { quantity: 0, position: 0 };

    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];

      if (count === node.quantity) {
        return node.position;
      }

      if (count < node.quantity) {
        const range = node.quantity - prev.quantity;
        const ratio = range > 0 ? (count - prev.quantity) / range : 0;
        return prev.position + ratio * (node.position - prev.position);
      }

      prev = node;
    }

    return lastNode.position;
  }

  function goalReachedKey(node, index) {
    return `${index}:${node.getAttribute('data-goal-threshold')}:${node.getAttribute('data-goal-reward')}`;
  }

  function playRewardConfetti() {
    const canvas = rewardConfetti;
    cancelAnimationFrame(rewardConfettiFrame);
    const run = ++rewardConfettiRun;

    if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (canvas.parentElement !== document.body) document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const width = window.innerWidth;
    const height = window.innerHeight;
    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const colors = ['#210073', '#f1d561', '#f5594d', '#c7d2ff', '#5ec4a0', '#ff8fb8', '#ffffff', '#ffec9e'];
    const pieces = [];
    const originX = width / 2;
    const originY = height * 0.38;

    for (let i = 0; i < 130; i += 1) {
      const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.2;
      const speed = 4 + Math.random() * 9;
      pieces.push({
        x: originX + (Math.random() - 0.5) * width * 0.35,
        y: originY + (Math.random() - 0.5) * 24,
        w: 5 + Math.random() * 6,
        h: 7 + Math.random() * 8,
        color: colors[i % colors.length],
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.28,
        circle: Math.random() > 0.72,
        gravity: 0.14 + Math.random() * 0.08
      });
    }

    const started = performance.now();
    const duration = 2800;

    const tick = (now) => {
      if (run !== rewardConfettiRun) return;
      const elapsed = now - started;
      ctx.clearRect(0, 0, width, height);
      pieces.forEach((piece) => {
        piece.vy += piece.gravity;
        piece.x += piece.vx;
        piece.y += piece.vy;
        piece.vx *= 0.992;
        piece.rot += piece.vr;
        ctx.save();
        ctx.translate(piece.x, piece.y);
        ctx.rotate(piece.rot);
        ctx.globalAlpha = Math.max(0, 1 - elapsed / duration);
        ctx.fillStyle = piece.color;
        if (piece.circle) {
          ctx.beginPath();
          ctx.arc(0, 0, piece.w * 0.45, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-piece.w / 2, -piece.h / 2, piece.w, piece.h);
        }
        ctx.restore();
      });

      if (elapsed < duration) {
        rewardConfettiFrame = requestAnimationFrame(tick);
      } else {
        ctx.clearRect(0, 0, width, height);
      }
    };

    rewardConfettiFrame = requestAnimationFrame(tick);
  }

  let goalCelebrationReady = false;

  function syncGoalCelebration(reachedIndexes) {
    const freshIndexes = [];

    if (goalCelebrationReady) {
      reachedIndexes.forEach((index) => {
        const key = goalReachedKey(goalNodes[index], index);
        if (!seenReachedGoals.has(key)) freshIndexes.push(index);
      });
    }

    seenReachedGoals.clear();
    reachedIndexes.forEach((index) => {
      seenReachedGoals.add(goalReachedKey(goalNodes[index], index));
    });

    goalCelebrationReady = true;
    if (freshIndexes.length) playRewardConfetti();
  }

  function updateUI() {
    const count = selectedVariantIds.length;
    const totals = getSelectionTotals(count);
    const cartonTotal = getCartonTotal();
    const goalSubtotal = totals.priceSubtotal + cartonTotal;
    const progress = getProgressPercent(goalsUsePrice() ? goalSubtotal : count);
    const goalPercent = getDiscountPercent(count);

    countEls.forEach((el) => {
      el.textContent = String(count);
    });

    if (goalsFill) {
      goalsFill.style.width = `${progress}%`;
    }

    const reachedGoalIndexes = [];

    goalNodes.forEach((node, index) => {
      const reward = node.getAttribute('data-goal-reward') || 'percent';
      const quantity = parseInt(node.getAttribute('data-goal-quantity'), 10);
      const threshold = parseInt(node.getAttribute('data-goal-threshold'), 10);
      const goalDiscount = parseInt(node.getAttribute('data-goal-discount'), 10);
      const discountEl = node.querySelector('.k7-sparset-builder__goal-discount');
      const reached = goalsUsePrice()
        ? (threshold === 0 ? goalSubtotal > 0 : goalSubtotal >= threshold)
        : count >= quantity;

      node.classList.toggle('is-reached', reached);
      goalListItems[index]?.classList.toggle('is-reached', reached);
      if (reached) reachedGoalIndexes.push(index);

      if (discountEl && reward === 'percent' && !discountEl.querySelector('img') && !Number.isNaN(goalDiscount)) {
        const shownPercent = getCombinedDiscountPercent(goalDiscount);
        discountEl.textContent = shownPercent > 0 ? `-${shownPercent}%` : `${goalDiscount}%`;
      }
    });

    syncGoalCelebration(reachedGoalIndexes);

    const filledGroups = getFilledSlotGroups();
    const filledCount = getFilledSlotCount();
    const selectableSlots = [];

    getSlotElements().forEach((slot) => {
      if (slot.hasAttribute('data-free-product-slot')) {
        renderFreeProductSlot(slot);
        return;
      }
      selectableSlots.push(slot);
    });

    const displayCount = filledGroups.length + Math.max(0, slotVariantIds.length - filledCount);

    selectableSlots.forEach((slot, index) => {
      const titleEl = slot.querySelector('[data-slot-title]');
      const subtitleEl = slot.querySelector('[data-slot-subtitle]');
      const qtyEl = slot.querySelector('[data-slot-qty]');
      const iconEl = slot.querySelector('.k7-sparset-builder__slot-icon');
      const removeBtn = slot.querySelector('[data-action="remove-slot"]');

      const clearSlotQty = () => {
        if (!qtyEl) return;
        qtyEl.hidden = true;
        qtyEl.textContent = '';
      };

      if (index >= displayCount) {
        slot.hidden = true;
        slot.classList.remove('is-filled', 'is-free-product');
        slot.removeAttribute('data-remove-storage-index');
        clearSlotQty();
        if (removeBtn) removeBtn.hidden = true;
        return;
      }

      slot.hidden = false;
      slot.classList.remove('is-free-product');

      const group = index < filledGroups.length ? filledGroups[index] : null;
      const product = group ? getVariantEntry(group.variantId) : null;

      if (product && group) {
        const displayTitle = getVariantDisplayTitle(product);
        slot.classList.add('is-filled');
        slot.setAttribute('data-remove-storage-index', String(group.storageIndex));
        if (titleEl) titleEl.textContent = displayTitle;
        if (qtyEl) {
          if (group.quantity > 1) {
            qtyEl.hidden = false;
            qtyEl.textContent = String(group.quantity);
            qtyEl.style.setProperty('--quantity-input-characters-count', `${String(group.quantity).length}ch`);
          } else {
            clearSlotQty();
          }
        }
        if (subtitleEl) {
          subtitleEl.innerHTML = renderPriceMarkup(
            product.price * group.quantity,
            goalPercent,
            (product.compareAtPrice || 0) * group.quantity,
            false
          );
        }
        if (iconEl) {
          iconEl.innerHTML = product.image
            ? `<img src="${product.image}" alt="${displayTitle.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
            : '';
        }
        if (removeBtn) removeBtn.hidden = false;
      } else {
        const emptyOffset = index - filledGroups.length;
        const logicalSlotIndex = (hasFreeProductSlot() ? 1 : 0) + filledCount + emptyOffset;
        slot.classList.remove('is-filled');
        slot.removeAttribute('data-remove-storage-index');
        clearSlotQty();
        if (titleEl) titleEl.textContent = config.emptySlotText || 'Wähle ein Produkt';
        if (subtitleEl) {
          subtitleEl.textContent = getGoalSubtitleForSlot(logicalSlotIndex);
        }
        if (iconEl) {
          iconEl.innerHTML = '<svg role="presentation" focusable="false" width="14" height="14" viewBox="0 0 10 10"><path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        }
        if (removeBtn) removeBtn.hidden = true;
      }
    });

    if (savingsRow && savingsAmountEl) {
      const savingsAmount = totals.savings + getUnlockedGoodieSavings();
      const showSavings = count > 0 && savingsAmount > 0;
      savingsRow.hidden = !showSavings;
      if (showSavings) {
        savingsAmountEl.textContent = formatSparsetMoney(savingsAmount);
      }
    }

    updatePreviewDiscountRow(count, totals);

    if (totalRow && totalPriceEl) {
      const showTotal = count > 0 || cartonTotal > 0;
      totalRow.hidden = !showTotal;

      if (showTotal) {
        totalPriceEl.textContent = formatSparsetMoney(totals.discountedTotal + cartonTotal);

        if (totalCompareEl) {
          if (goalPercent > 0 && totals.discountedTotal < totals.originalTotal) {
            totalCompareEl.textContent = formatSparsetMoney(totals.originalTotal + cartonTotal);
            totalCompareEl.hidden = false;
          } else {
            totalCompareEl.textContent = '';
            totalCompareEl.hidden = true;
          }
        }
      }
    }

    syncAtcMode(count);

    updateCartonNotice();
    updateCartonFill();
    updateCartonFitNotice();
    updateProductCards();
    maybeRetryPreviewDiscount(count);
  }

  function addProduct(variantId, options = {}) {
    if (!variantId) return false;
    let entry = getVariantEntry(variantId);
    if (!entry && options.card) {
      entry = ensureVariantEntryFromCard(options.card, variantId);
    }
    if (!entry) return false;

    let emptyIndex = slotVariantIds.findIndex((id) => !id);
    if (emptyIndex < 0) {
      ensureSelectableSlots(slotVariantIds.length + 1);
      emptyIndex = slotVariantIds.length - 1;
    }

    slotVariantIds[emptyIndex] = String(variantId);
    syncSelectedVariantIdsFromSlots();

    if (options.card) {
      options.card.setAttribute('data-variant-id', String(variantId));
      options.card.setAttribute('data-base-price', String(entry.price || 0));
      options.card.setAttribute('data-compare-at-price', String(entry.compareAtPrice || 0));
    }

    updateUI();
    return true;
  }

  function removeProductAtSlot(storageIndex) {
    if (storageIndex < 0 || storageIndex >= slotVariantIds.length) return;
    slotVariantIds[storageIndex] = null;
    trimExtraSlots();
    syncSelectedVariantIdsFromSlots();
    updateUI();
  }

  function handleCardAdd(card) {
    if (!card || card.getAttribute('data-available') !== 'true') return;
    addProduct(card.getAttribute('data-variant-id'), { card });
  }

  function activateSparsetCard(card) {
    if (!card || card.getAttribute('data-available') !== 'true') return;
    if (card.hasAttribute('data-sparset-carton-card')) {
      if (cartonToggle) cartonToggle.checked = true;
      cartonWanted = true;
      updateUI();
      return;
    }
    handleCardAdd(card);
  }

  if (showReferralCode) {
    referralInput?.addEventListener('input', function () {
      referralCodeValue = referralInput.value.trim();
    });
  }

  root.addEventListener('click', function (event) {
    const card = event.target.closest('[data-sparset-card], .k7-sparset-builder__card');
    if (card && productList && productList.contains(card)) {
      const productLink = event.target.closest('a[href]');
      if (productLink && card.contains(productLink) && (productLink.getAttribute('href') || '').includes('/products/')) {
        event.preventDefault();
      }

      if (!event.target.closest('quantity-selector, [data-sparset-quantity-wrap], [data-action], button, input, select, textarea, label, .k7-trusted-shops-stars, etrusted-widget')) {
        activateSparsetCard(card);
        return;
      }
    }

    const addProductBtn = event.target.closest('[data-action="add-product"]');
    if (addProductBtn) {
      const addCard = addProductBtn.closest('[data-sparset-card], .k7-sparset-builder__card');
      if (!addCard || addProductBtn.disabled) return;
      event.preventDefault();
      activateSparsetCard(addCard);
      return;
    }

    const removeSlotBtn = event.target.closest('[data-action="remove-slot"]');
    if (removeSlotBtn) {
      const slot = removeSlotBtn.closest('.k7-sparset-builder__slot');
      if (!slot || slot.hasAttribute('data-free-product-slot')) return;
      const storageIndex = parseInt(slot.getAttribute('data-remove-storage-index'), 10);
      if (Number.isNaN(storageIndex)) return;
      removeProductAtSlot(storageIndex);
      return;
    }

    const toggleBtn = event.target.closest('[data-action="toggle-panel"]');
    if (toggleBtn && panel) {
      const expanded = panel.getAttribute('data-expanded') === 'true';
      panel.setAttribute('data-expanded', expanded ? 'false' : 'true');
      toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      syncAtcMode(getFilledSlotCount());
      return;
    }

    const atcBtn = event.target.closest('[data-action="add-to-cart"]');
    if (atcBtn) {
      if (isMobilePanelCollapsed()) {
        panel?.setAttribute('data-expanded', 'true');
        root.querySelector('[data-action="toggle-panel"]')?.setAttribute('aria-expanded', 'true');
        syncAtcMode(getFilledSlotCount());
        return;
      }
      handleAddToCart(atcBtn);
    }
  });

  document.addEventListener('click', function (event) {
    if (!panel || panel.getAttribute('data-expanded') !== 'true') return;
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    if (panel.contains(event.target)) return;
    panel.setAttribute('data-expanded', 'false');
    root.querySelector('[data-action="toggle-panel"]')?.setAttribute('aria-expanded', 'false');
    syncAtcMode(getFilledSlotCount());
  });

  function getReferralCodeFromUrl() {
    const param = (config.referralUrlParam || 'ref').trim();
    if (!param) return '';

    try {
      const value = new URLSearchParams(window.location.search).get(param);
      return value ? value.trim() : '';
    } catch (error) {
      return '';
    }
  }

  function getActiveReferralCode() {
    const fromInput = referralInput?.value?.trim();
    if (fromInput) return fromInput;
    if (referralCodeValue) return referralCodeValue;
    return (config.defaultReferralCode || '').trim();
  }

  function initReferralCode() {
    referralCodeValue = getReferralCodeFromUrl() || (config.defaultReferralCode || '').trim();

    if (showReferralCode && referralInput && referralCodeValue) {
      referralInput.value = referralCodeValue;
    }
  }

  async function updateCartTrackingAttributes(referralCode, discountPercent, bundleMeta = null) {
    const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
    const attributes = {};

    if (cartBefore.attributes) {
      Object.keys(cartBefore.attributes).forEach((key) => {
        const value = cartBefore.attributes[key];
        if (value != null && String(value).trim() !== '') {
          attributes[key] = String(value);
        }
      });
    }

    if (referralCode) {
      attributes.referral_code = referralCode;
    } else if (showReferralCode) {
      delete attributes.referral_code;
    }

    if (bundleMeta?.bundleId && bundleMeta.bundleComponents) {
      attributes[`bundle_components_${bundleMeta.bundleId}`] = bundleMeta.bundleComponents;
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('Failed to update cart tracking attributes');
    }

    return response.json();
  }

  function generateBundleId(group) {
    const bundleGroup = String(group || 'wunschset').trim().replace(/-/g, '') || 'wunschset';
    let instanceId;

    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      instanceId = crypto.randomUUID().replace(/-/g, '');
    } else {
      instanceId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    }

    return `${bundleGroup}-${instanceId}`;
  }

  function toProductVariantGid(id) {
    if (id == null || id === '') return '';
    const raw = String(id).trim();
    if (raw.indexOf('gid://shopify/ProductVariant/') === 0) return raw;
    const numeric = parseInt(raw, 10);
    if (!numeric) return '';
    return `gid://shopify/ProductVariant/${numeric}`;
  }

  function buildBundleComponentsProperty(itemQuantities) {
    return Object.keys(itemQuantities).map((id) => {
      const qty = itemQuantities[id];
      const product = getVariantEntry(id);
      const title = encodeURIComponent(getVariantDisplayTitle(product) || product?.productTitle || '');
      const image = product?.image ? encodeURIComponent(product.image) : '';
      return image ? `${id}::${qty}::${title}::${image}` : `${id}::${qty}::${title}`;
    }).join('||');
  }

  function bundleLineProperties(bundleId, parentVariantId, bundleTitle, bundleTotals, bundleComponents, tracking = {}) {
    const props = {
      _BundleId: bundleId,
      _DiscountId: bundleId
    };

    const parentVariantGid = toProductVariantGid(parentVariantId);
    if (parentVariantGid) {
      props._BundleParentVariantId = parentVariantGid;
    }

    if (config.parentHandle) {
      props._BundleParentHandle = String(config.parentHandle);
    }

    if (config.parentImage) {
      props._BundleParentImage = String(config.parentImage);
    }

    if (bundleTitle) {
      props._BundleTitle = bundleTitle;
    }

    if (tracking.referralCode) {
      props._BundleReferralCode = tracking.referralCode;
    }

    return props;
  }

  async function handleAddToCart(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    if (selectedVariantIds.length < minProducts) return;

    const parentVariantId = config.parentVariantId ? parseInt(config.parentVariantId, 10) : null;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const bundleId = generateBundleId(config.bundleGroup || 'starter');
      const bundleTotals = getSelectionTotals(selectedVariantIds.length);
      const discountPercent = getDiscountPercent(selectedVariantIds.length);
      const referralCode = getActiveReferralCode();

      const itemQuantities = {};
      selectedVariantIds.forEach((variantId) => {
        const id = parseInt(variantId, 10);
        itemQuantities[id] = (itemQuantities[id] || 0) + 1;
      });

      const cartonQty = getCartonQuantity();
      const cartonId = config.cartonVariantId ? parseInt(config.cartonVariantId, 10) : null;
      const cartonInsideBundle = cartonQty > 0 && cartonId && cartonId !== parentVariantId && !config.cartonAsGoodie;
      if (cartonInsideBundle && !itemQuantities[cartonId]) {
        itemQuantities[cartonId] = cartonQty;
      }

      const bundleComponents = buildBundleComponentsProperty(itemQuantities);

      const lineProps = bundleLineProperties(
        bundleId,
        parentVariantId,
        (config.bundleTitle || '').trim(),
        bundleTotals,
        bundleComponents,
        { referralCode, discountPercent }
      );

      const items = [];

      Object.keys(itemQuantities).forEach((id) => {
        const variantId = parseInt(id, 10);
        if (!variantId || (parentVariantId && variantId === parentVariantId)) return;

        items.push({
          id: variantId,
          quantity: itemQuantities[id],
          properties: lineProps
        });
      });

      const freeVariantId = config.freeProduct?.variantId ? parseInt(config.freeProduct.variantId, 10) : null;
      if (freeVariantId && !itemQuantities[freeVariantId] && freeVariantId !== parentVariantId) {
        items.push({
          id: freeVariantId,
          quantity: 1,
          properties: {
            _DiscountId: bundleId
          }
        });
        itemQuantities[freeVariantId] = 1;
      }

      const pushGoodie = (variantId) => {
        const goodieId = parseInt(variantId, 10);
        if (!goodieId || itemQuantities[goodieId] || goodieId === parentVariantId) return;

        items.push({
          id: goodieId,
          quantity: 1,
          properties: {
            _DiscountId: bundleId
          }
        });
        itemQuantities[goodieId] = 1;
      };

      goals.forEach((goal) => {
        if (goal.reward !== 'goodie') return;
        if (bundleTotals.priceSubtotal + getCartonTotal() < goal.threshold) return;
        pushGoodie(goal.variantId);
        pushGoodie(goal.variantId2);
      });

      if (config.cartonAsGoodie && cartonQty > 0 && cartonId && cartonId !== parentVariantId && !itemQuantities[cartonId]) {
        items.push({
          id: cartonId,
          quantity: cartonQty,
          properties: {
            _DiscountId: bundleId
          }
        });
        itemQuantities[cartonId] = cartonQty;
      }

      if (!items.length) return;

      const nativeCartDrawer = document.querySelector('cart-drawer');
      const requestBody = { items };

      if (nativeCartDrawer) {
        const sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        const sectionId = getCartDrawerSectionId(nativeCartDrawer);
        if (sectionId && !sectionsToBundle.includes(sectionId)) {
          sectionsToBundle.push(sectionId);
        }
        requestBody.sections = sectionsToBundle.join(',');
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add items to cart');
      }

      const responseJson = await response.json();

      await updateCartTrackingAttributes(referralCode, discountPercent, {
        bundleId,
        bundleComponents,
        totals: {
          priceSubtotal: bundleTotals.priceSubtotal,
          discountedTotal: bundleTotals.discountedTotal,
          compareSubtotal: bundleTotals.compareSubtotal,
          discountPercent
        }
      });

      let cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

      if (nativeCartDrawer) {
        cartContent = await attachCartDrawerSections(cartContent, nativeCartDrawer);
      } else if (responseJson.sections) {
        if (!cartContent.sections) cartContent.sections = {};
        Object.assign(cartContent.sections, responseJson.sections);
      }

      const productForm = document.querySelector('form[is="product-form"]');
      const formToUse = productForm || document.createElement('form');
      let formAdded = false;

      if (!productForm) {
        document.body.appendChild(formToUse);
        formAdded = true;
      }

      formToUse.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        cancelable: true,
        detail: {
          items: responseJson.items || [responseJson],
          cart: cartContent
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      }));

      if (formAdded) {
        document.body.removeChild(formToUse);
      }

      const shouldUseNativeCartDrawer = nativeCartDrawer
        && window.themeVariables?.settings?.cartType === 'drawer';

      if (!shouldUseNativeCartDrawer) {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
        } else {
          window.dispatchEvent(new CustomEvent('rebuy:cart.open'));
        }
      }
    } catch (error) {
      console.error('Error adding sparset to cart:', error);
      alert(error.message || 'Produkte konnten nicht hinzugefügt werden.');
    } finally {
      button.removeAttribute('aria-busy');
      syncAtcMode(selectedVariantIds.length);
    }
  }

  let resizeTimeout;
  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      adjustGoalNodePositions();
      updateUI();
    }, 150);
  };

  window.addEventListener('resize', onResize);

  const fallbackPreviewPercent = getPreviewDiscountFallbackPercent();
  resolvedPreviewDiscount = {
    type: fallbackPreviewPercent > 0 ? 'percentage' : null,
    value: fallbackPreviewPercent,
    code: null,
    loaded: true
  };

  initReferralCode();
  initSlotVariantIds();

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const isActive = button.getAttribute('aria-pressed') === 'true';
      if (isActive && button.getAttribute('data-filter-all') !== 'true') {
        const allButton = root.querySelector('[data-sparset-filter][data-filter-all="true"]');
        setActiveFilter(allButton || button);
        return;
      }
      setActiveFilter(button);
    });
  });

  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      const isOpen = searchWrap?.classList.contains('is-open');
      setSearchOpen(!isOpen);
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', filterProductCards);
    searchInput.addEventListener('search', filterProductCards);
    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setSearchOpen(false);
        searchToggle?.focus();
      }
    });
  }

  requestAnimationFrame(() => {
    adjustGoalNodePositions();
    updateUI();
    filterProductCards();
  });

  if ((config.previewDiscountCode || '').trim()) {
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  root._k7SparsetInitialized = true;
}

function initAllK7SparsetBuilders() {
  document.querySelectorAll('k7-sparset-builder').forEach(initK7SparsetBuilder);
}

document.addEventListener('DOMContentLoaded', initAllK7SparsetBuilders);
document.addEventListener('shopify:section:load', function (event) {
  setTimeout(function () {
    const builders = event.target ? event.target.querySelectorAll('k7-sparset-builder') : [];
    if (builders.length) {
      builders.forEach(function (root) {
        root._k7SparsetInitialized = false;
        initK7SparsetBuilder(root);
      });
      return;
    }
    initAllK7SparsetBuilders();
  }, 100);
});

function initK7AccessGoOffset() {
  if (!document.querySelector('k7-sparset-builder')) return;

  const gap = 16;
  const buttonSize = 48;
  let resizeObserver = null;
  let observedBar = null;
  let baseOffset = null;

  function getStickyBar() {
    const bars = document.querySelectorAll('.k7-sparset-builder__sidebar');

    for (let index = 0; index < bars.length; index += 1) {
      if (getComputedStyle(bars[index]).position === 'fixed') return bars[index];
    }

    return null;
  }

  function getAccessGoButton() {
    const widget = document.querySelector('ago-accessibility-widget');
    if (!widget) return null;

    const root = widget.shadowRoot || widget;
    return root.querySelector('ago-accessibility-button');
  }

  function applyOffset() {
    const button = getAccessGoButton();
    if (!button) return false;

    if (baseOffset == null) {
      const current = Number(button.offsetY);
      if (!Number.isFinite(current)) return false;
      baseOffset = current;
    }

    const bar = getStickyBar();
    let next = baseOffset;

    if (bar) {
      const maxBottom = Math.max(gap, window.innerHeight - buttonSize - gap);
      next = Math.min(Math.ceil(bar.getBoundingClientRect().height) + gap, maxBottom);
    }

    if (Number(button.offsetY) !== next) {
      button.offsetY = next;
      button.style.bottom = `${next}px`;
    }

    if (bar !== observedBar) {
      if (resizeObserver) resizeObserver.disconnect();
      observedBar = bar;

      if (bar && typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(applyOffset);
        resizeObserver.observe(bar);
      }
    }

    return true;
  }

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    const button = getAccessGoButton();
    applyOffset();

    const settled = button && (getStickyBar() || window.matchMedia('(min-width: 1000px)').matches);
    if (settled || attempts > 40) window.clearInterval(timer);
  }, 250);

  window.addEventListener('resize', applyOffset, { passive: true });
  document.addEventListener('shopify:section:load', () => {
    observedBar = null;
    window.setTimeout(applyOffset, 50);
  });

  applyOffset();
}

document.addEventListener('DOMContentLoaded', initK7AccessGoOffset);

/* k7-sparset-builder end */

/* k7-bundle-cart-components start */

function initK7BundleCartComponents() {
  document.querySelectorAll('.k7-line-item-components-disclosure').forEach((disclosure) => {
    disclosure.open = true;
    disclosure.setAttribute('aria-expanded', 'true');
  });
}

document.addEventListener('DOMContentLoaded', initK7BundleCartComponents);
document.addEventListener('cart:change', () => {
  requestAnimationFrame(initK7BundleCartComponents);
});
document.addEventListener('shopify:section:load', () => {
  setTimeout(initK7BundleCartComponents, 100);
});

/* k7-bundle-cart-components end */

/* k7-rebuy-bundle-compare start */

function stripNobuyRebuyLinks(cart) {
  const flyout = document.querySelector('.rebuy-cart__flyout');
  if (!flyout || !Array.isArray(cart?.items)) return;

  cart.items.forEach((item, index) => {
    if (item.handle !== 'wunschset') return;

    const row = flyout.querySelector(`[data-rebuy-cart-item-index="${index}"]`);
    if (!row) return;

    const root = window.Shopify?.routes?.root || '/';
    const pageUrl = `${root}pages/wunschset`;
    /* B2B Wunschset */
    const hideWunschset = document.documentElement.hasAttribute('data-k7-hide-wunschset');
    /* end B2B Wunschset */

    row.querySelectorAll('a').forEach((link) => {
      const href = link.getAttribute('href') || '';
      /* B2B Wunschset */
      if (hideWunschset && (href.includes('/products/wunschset') || href.includes('/pages/wunschset'))) {
        link.removeAttribute('href');
        return;
      }
      /* end B2B Wunschset */
      if (!href.includes('/products/wunschset')) return;
      link.setAttribute('href', pageUrl);
    });
  });
}

function getCartItemProperties(item) {
  const props = {};

  if (!item || !item.properties) {
    return props;
  }

  if (Array.isArray(item.properties)) {
    item.properties.forEach((entry) => {
      const key = entry.name || entry.first || entry.key;
      const value = entry.value || entry.last;
      if (key) {
        props[key] = value;
      }
    });
    return props;
  }

  if (typeof item.properties === 'object') {
    return { ...item.properties };
  }

  return props;
}

function parseBundlePricing(props) {
  const raw = props._BundlePricing || props['Bundle pricing'];
  if (!raw || typeof raw !== 'string') {
    return null;
  }

  const parts = raw.split('|').map((value) => parseInt(value, 10));
  if (parts.length < 4 || parts.some((value) => Number.isNaN(value))) {
    return null;
  }

  return {
    compareTotal: parts[0],
    saleTotal: parts[1],
    discountPercent: parts[2],
    compareAtTotal: parts[3]
  };
}

function getBundleSaleCents(item, cartItems) {
  const props = getCartItemProperties(item);
  const bundlePricing = parseBundlePricing(props);
  const bundleId = props._BundleId;

  if (props._BundleRole === 'child' || props['Bundle role'] === 'child') {
    return item.final_line_price || item.line_price || 0;
  }

  if (bundlePricing?.saleTotal > 0) {
    return bundlePricing.saleTotal;
  }

  let saleCents = item.final_line_price || item.line_price || 0;

  if (!bundleId || !Array.isArray(cartItems)) {
    return saleCents;
  }

  saleCents = cartItems.reduce((sum, line) => {
    const lineProps = getCartItemProperties(line);
    if (lineProps._BundleId !== bundleId) {
      return sum;
    }

    return sum + (line.final_line_price || line.line_price || 0);
  }, 0);

  const discountPercent = parseInt(props._BundleDiscountPercent, 10) || bundlePricing?.discountPercent || 0;
  const discountedTotal = parseInt(props._BundleDiscountedTotal, 10) || bundlePricing?.saleTotal || 0;

  if (discountPercent > 0 && discountedTotal > 0) {
    saleCents = discountedTotal;
  }

  return saleCents;
}

function getBundleCompareCents(item, cartItems) {
  const props = getCartItemProperties(item);
  const bundlePricing = parseBundlePricing(props);
  const saleCents = getBundleSaleCents(item, cartItems);
  const compareFromProps = parseInt(props._BundleCompareTotal, 10) || bundlePricing?.compareTotal || 0;

  if (compareFromProps > saleCents) {
    return compareFromProps;
  }

  const compareAtFromProps = parseInt(props._BundleCompareAtTotal, 10) || bundlePricing?.compareAtTotal || 0;
  if ((props._BundleShowVariantCompareAt === 'true' || compareAtFromProps > compareFromProps) && compareAtFromProps > saleCents) {
    return compareAtFromProps;
  }

  const finalCents = item.final_line_price || item.line_price || 0;

  if (item.original_line_price > saleCents) {
    return item.original_line_price;
  }

  if (item.variant?.compare_at_price > item.variant?.price) {
    const variantCompare = (item.variant.compare_at_price || 0) * (item.quantity || 1);
    if (variantCompare > saleCents) {
      return variantCompare;
    }
  }

  if (compareFromProps > finalCents) {
    return compareFromProps;
  }

  return 0;
}

function formatCartMoney(cents) {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat);
  }

  return `${(cents / 100).toFixed(2)}`;
}

function injectRebuyBundleComparePrices(cart) {
  if (!window.Rebuy || !cart?.items?.length) {
    return;
  }

  const flyout = document.querySelector('.rebuy-cart__flyout');
  if (!flyout) {
    return;
  }

  cart.items.forEach((item, index) => {
    const props = getCartItemProperties(item);
    if (props._BundleRole === 'child' || props['Bundle role'] === 'child') {
      return;
    }

    const compareCents = getBundleCompareCents(item, cart.items);
    if (!compareCents) {
      return;
    }

    const saleCents = getBundleSaleCents(item, cart.items);
    const row = flyout.querySelector(`[data-rebuy-cart-item-index="${index}"]`) || flyout.querySelector(`[data-line-item-key="${item.key}"]`);
    const priceEl = row?.querySelector('.rebuy-cart__flyout-item-price, .rebuy-money');

    if (!priceEl || priceEl.dataset.k7BundleCompareApplied === 'true') {
      return;
    }

    priceEl.dataset.k7BundleCompareApplied = 'true';
    priceEl.innerHTML = `<span class="rebuy-money sale-price">${formatCartMoney(saleCents)}</span><span class="rebuy-money compare-at-price text-subdued line-through">${formatCartMoney(compareCents)}</span>`;
  });
}

async function refreshRebuyBundleComparePrices() {
  if (!window.Rebuy) {
    return;
  }

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    requestAnimationFrame(() => {
      injectRebuyBundleComparePrices(cart);
      stripNobuyRebuyLinks(cart);
    });
    setTimeout(() => stripNobuyRebuyLinks(cart), 300);
  } catch (error) {
    console.error('Failed to refresh Rebuy bundle compare prices:', error);
  }
}

document.addEventListener('DOMContentLoaded', refreshRebuyBundleComparePrices);
document.addEventListener('cart:change', refreshRebuyBundleComparePrices);
document.addEventListener('rebuy:cart.change', refreshRebuyBundleComparePrices);
document.addEventListener('rebuy:smartcart.show', refreshRebuyBundleComparePrices);

/* k7-rebuy-bundle-compare end */

/* k7-bundle-free-shipping start */

function getBundleParentIdsForShipping(cartItems) {
  const parentIds = new Set();

  cartItems.forEach((item) => {
    const props = getCartItemProperties(item);
    if (!props._BundleId) return;

    if (
      props._BundleRole === 'parent'
      || props._BundleIsParent === 'true'
      || props._BundleTitle
      || props._BundleComponents
      || (Array.isArray(item.item_components) && item.item_components.length > 0)
      || item.has_components
    ) {
      parentIds.add(props._BundleId);
    }
  });

  return parentIds;
}

function bundleHasShippableContent(item, props, cartItems) {
  if (Array.isArray(item.item_components) && item.item_components.length > 0) {
    return item.item_components.some((component) => component.requires_shipping === true);
  }

  const hasShippableChild = cartItems.some((line) => {
    const lineProps = getCartItemProperties(line);
    return lineProps._BundleId === props._BundleId
      && (lineProps._BundleRole === 'child' || lineProps['Bundle role'] === 'child')
      && line.requires_shipping === true;
  });

  if (hasShippableChild) {
    return true;
  }

  return item.requires_shipping === true;
}

function getBundleShippingTotalCents(item, cartItems, cartAttributes) {
  const props = getCartItemProperties(item);
  const bundleId = props._BundleId;
  const attrSale = bundleId && cartAttributes?.[`bundle_sale_total_${bundleId}`];

  if (attrSale) {
    return parseInt(attrSale, 10) || 0;
  }

  const saleCents = getBundleSaleCents(item, cartItems);
  if (saleCents > 0) {
    return saleCents;
  }

  return item.final_line_price || item.line_price || 0;
}

function getFreeShippingEligibleTotal(cart) {
  const items = cart?.items || [];
  if (!items.length) {
    return 0;
  }

  const bundleParentIds = getBundleParentIdsForShipping(items);
  const countedBundles = new Set();
  let total = 0;

  items.forEach((item) => {
    const props = getCartItemProperties(item);
    const bundleId = props._BundleId;
    const isHiddenChild = (props._BundleRole === 'child' || props['Bundle role'] === 'child')
      && bundleId
      && bundleParentIds.has(bundleId);

    if (isHiddenChild) {
      return;
    }

    if (bundleId && bundleParentIds.has(bundleId)) {
      if (props._BundleRole === 'child' || props['Bundle role'] === 'child') {
        return;
      }

      if (countedBundles.has(bundleId)) {
        return;
      }

      if (!bundleHasShippableContent(item, props, items)) {
        return;
      }

      countedBundles.add(bundleId);
      total += getBundleShippingTotalCents(item, items, cart.attributes);
      return;
    }

    if (item.requires_shipping) {
      total += item.final_line_price || item.line_price || 0;
    }
  });

  const cartDiscount = (cart.cart_level_discount_applications || [])
    .reduce((sum, allocation) => sum + (allocation.total_allocated_amount || 0), 0);

  return Math.max(0, total - cartDiscount);
}

function updateFreeShippingBars(cart) {
  document.querySelectorAll('free-shipping-bar').forEach((bar) => {
    bar.setAttribute('total-price', String(getFreeShippingEligibleTotal(cart)));
  });
}

function initFreeShippingBarTotals() {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((cart) => updateFreeShippingBars(cart))
    .catch(() => {});
}


function initK7BundleFreeShippingBarPatch() {
  customElements.whenDefined('free-shipping-bar').then(() => {
    const FreeShippingBar = customElements.get('free-shipping-bar');
    if (!FreeShippingBar || FreeShippingBar.prototype._k7BundleFreeShippingPatched) return;

    FreeShippingBar.prototype._k7BundleFreeShippingPatched = true;
    FreeShippingBar.prototype._onCartChanged = function(event) {
      if (!event.detail?.cart) return;
      this.setAttribute('total-price', String(getFreeShippingEligibleTotal(event.detail.cart)));
    };
    FreeShippingBar.prototype._updateMessage = function() {
      const messageElement = this.querySelector('span');
      if (!messageElement) return;
      if (this.totalPrice >= this.threshold) {
        messageElement.innerHTML = this.getAttribute('reached-message');
      } else {
        const amount = this._currencyFormatter.format((this.threshold - this.totalPrice) / 100).replace(/\$/g, '$$$$');
        const replacement = this.classList.contains('k7-free-shipping')
          ? amount
          : `<span class="bold text-accent">${amount}</span>`;
        messageElement.innerHTML = this.getAttribute('unreached-message').replace(/({{.*}})/g, replacement);
      }
      if (!this.classList.contains('k7-free-shipping')) return;
      const threshold = parseFloat(this.getAttribute('threshold'));
      const total = parseFloat(this.getAttribute('total-price'));
      if (!threshold || isNaN(total)) return;
      this.classList.toggle('k7-free-shipping--reached', total >= threshold);
    };
    document.querySelectorAll('free-shipping-bar.k7-free-shipping').forEach((bar) => {
      bar._updateMessage();
    });
  });
}

initK7BundleFreeShippingBarPatch();

document.addEventListener('DOMContentLoaded', initFreeShippingBarTotals);
document.addEventListener('cart:change', (event) => {
  if (!event.detail?.cart) return;

  requestAnimationFrame(() => {
    updateFreeShippingBars(event.detail.cart);
  });
});
document.addEventListener('cart:refresh', initFreeShippingBarTotals);

/* k7-bundle-free-shipping end */

/* ========================================
   K7 QUANTITY PRESETS
   ======================================== */

function k7FormatMoney(cents, format) {
  const value = (Number(cents) / 100).toFixed(2);
  const formatString = format || '{{amount}}';
  if (formatString.includes('{{amount_with_comma_separator}}')) {
    return formatString.replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  }
  if (formatString.includes('{{amount_no_decimals}}')) {
    return formatString.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
  }
  return formatString.replace('{{amount}}', value);
}

function initK7QuantityPresets(root = document) {
  root.querySelectorAll('[data-k7-quantity-presets]').forEach((wrap) => {
    if (wrap.dataset.k7Init === 'true') return;
    wrap.dataset.k7Init = 'true';

    const input = wrap.querySelector('[data-k7-quantity-input]');
    const cards = wrap.querySelectorAll('[data-k7-quantity-preset]');
    if (!input || !cards.length) return;

    const selectCard = (card) => {
      const qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      input.value = String(qty);
      input.dispatchEvent(new Event('change', { bubbles: true }));

      cards.forEach((item) => {
        const selected = item === card;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => selectCard(card));
    });

    const selected = wrap.querySelector('[data-k7-quantity-preset].is-selected') || cards[0];
    if (selected) selectCard(selected);
  });
}

document.addEventListener('DOMContentLoaded', () => initK7QuantityPresets());
document.addEventListener('shopify:section:load', (event) => {
  initK7QuantityPresets(event.target);
});
document.addEventListener('product:rerender', () => {
  setTimeout(() => initK7QuantityPresets(), 50);
});

document.addEventListener('variant:change', (event) => {
  const variant = event.detail && event.detail.variant;
  if (!variant || typeof variant.price !== 'number') return;

  document.querySelectorAll('[data-k7-quantity-presets]').forEach((wrap) => {
    wrap.setAttribute('data-unit-price', String(variant.price));
    const format = wrap.getAttribute('data-money-format') || '';
    const isDouble = wrap.hasAttribute('data-k7-double');
    wrap.querySelectorAll('[data-k7-quantity-preset]').forEach((card) => {
      const qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      const discount = parseInt(card.getAttribute('data-discount'), 10) || 0;
      let unitFinal;
      let totalFinal;
      let totalCompare;

      if (isDouble) {
        const paid = parseInt(card.getAttribute('data-paid-qty'), 10) || 1;
        totalFinal = variant.price * paid;
        totalCompare = variant.price * qty;
        unitFinal = Math.round(totalFinal / qty);
      } else {
        const unitDiscount = Math.floor((variant.price * discount) / 100);
        unitFinal = variant.price - unitDiscount;
        totalFinal = unitFinal * qty;
        totalCompare = variant.price * qty;
      }

      const totalEl = card.querySelector('[data-k7-total]');
      const compareEl = card.querySelector('[data-k7-compare]');
      const unitEl = card.querySelector('[data-k7-unit]');
      if (totalEl) totalEl.textContent = k7FormatMoney(totalFinal, format);
      if (compareEl) {
        compareEl.textContent = k7FormatMoney(totalCompare, format);
        if (isDouble) compareEl.classList.remove('is-empty');
      }
      if (unitEl) unitEl.textContent = `${k7FormatMoney(unitFinal, format)} / Stück`;
    });
  });
});

/* k7-quantity-presets end */

/* ========================================
   K7 ARTICLE MAGAZINE
   ======================================== */

function k7Slugify(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
    .slice(0, 64);
}

function k7EaseInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function k7SmoothScrollTo(el, duration = 900) {
  return new Promise((resolve) => {
    if (!el) {
      resolve();
      return;
    }

    const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    const offset = headerOffset + 16;
    const startY = window.pageYOffset;
    const targetY = el.getBoundingClientRect().top + startY - offset;
    const distance = targetY - startY;

    if (Math.abs(distance) < 1) {
      resolve();
      return;
    }

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      window.scrollTo(0, startY + distance * k7EaseInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        resolve();
      }
    };
    requestAnimationFrame(step);
  });
}

function k7FormatAudioDuration(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const total = Math.max(0, Math.floor(seconds));
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
}

function initK7ArticleVoice(magazine) {
  const voice = magazine.querySelector('[data-k7-article-voice]');
  if (!voice || voice.hasAttribute('data-placeholder') || voice.dataset.k7VoiceInit === 'true') return;
  voice.dataset.k7VoiceInit = 'true';

  const audio = voice.querySelector('[data-k7-voice-audio]');
  const toggle = voice.querySelector('[data-k7-voice-toggle]');
  const progressEl = voice.querySelector('[data-k7-voice-progress]');
  const currentEl = voice.querySelector('[data-k7-voice-current]');
  const durationEl = voice.querySelector('[data-k7-voice-duration]');
  if (!audio || !toggle) return;

  const bars = progressEl ? Array.from(progressEl.children) : [];
  let seeking = false;

  const setPlaying = (playing) => {
    voice.classList.toggle('is-playing', playing);
    toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
  };

  const getDuration = () => {
    if (Number.isFinite(audio.duration) && audio.duration > 0 && audio.duration !== Infinity) {
      return audio.duration;
    }
    return 0;
  };

  const updateProgress = () => {
    const duration = getDuration();
    const current = audio.currentTime || 0;
    const ratio = duration > 0 ? Math.min(1, Math.max(0, current / duration)) : 0;

    if (currentEl) currentEl.textContent = k7FormatAudioDuration(current);
    if (durationEl) durationEl.textContent = k7FormatAudioDuration(duration);

    if (progressEl) {
      progressEl.style.setProperty('--k7-voice-progress', String(ratio));
      progressEl.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
      progressEl.setAttribute('aria-valuetext', `${k7FormatAudioDuration(current)} / ${k7FormatAudioDuration(duration)}`);
    }

    if (bars.length) {
      bars.forEach((bar, index) => {
        const threshold = (index + 0.5) / bars.length;
        bar.classList.toggle('is-played', ratio >= threshold);
      });
    }
  };

  const seekFromClientX = (clientX) => {
    if (!progressEl) return;
    const duration = getDuration();
    if (!duration) return;
    const rect = progressEl.getBoundingClientRect();
    if (!rect.width) return;
    const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    audio.currentTime = ratio * duration;
    updateProgress();
  };

  const resolveDuration = () => {
    if (getDuration()) {
      updateProgress();
      return;
    }
    const onTimeUpdate = () => {
      if (!getDuration()) return;
      audio.removeEventListener('timeupdate', onTimeUpdate);
      audio.currentTime = 0;
      updateProgress();
    };
    audio.addEventListener('timeupdate', onTimeUpdate);
    try {
      audio.currentTime = 1e101;
    } catch (error) {
      audio.removeEventListener('timeupdate', onTimeUpdate);
    }
  };

  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    if (!audio.src) return;
    if (audio.paused) {
      audio.play().catch(() => setPlaying(false));
    } else {
      audio.pause();
    }
  });

  if (progressEl) {
    progressEl.addEventListener('pointerdown', (event) => {
      if (event.button != null && event.button !== 0) return;
      event.preventDefault();
      seeking = true;
      progressEl.setPointerCapture?.(event.pointerId);
      seekFromClientX(event.clientX);
    });

    progressEl.addEventListener('pointermove', (event) => {
      if (!seeking) return;
      seekFromClientX(event.clientX);
    });

    const endSeek = (event) => {
      if (!seeking) return;
      seeking = false;
      if (event?.pointerId != null) {
        try {
          progressEl.releasePointerCapture?.(event.pointerId);
        } catch (error) {}
      }
      updateProgress();
    };

    progressEl.addEventListener('pointerup', endSeek);
    progressEl.addEventListener('pointercancel', endSeek);

    progressEl.addEventListener('keydown', (event) => {
      const duration = getDuration();
      if (!duration) return;
      const step = Math.max(duration * 0.05, 1);
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        event.preventDefault();
        audio.currentTime = Math.min(duration, audio.currentTime + step);
        updateProgress();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        event.preventDefault();
        audio.currentTime = Math.max(0, audio.currentTime - step);
        updateProgress();
      } else if (event.key === 'Home') {
        event.preventDefault();
        audio.currentTime = 0;
        updateProgress();
      } else if (event.key === 'End') {
        event.preventDefault();
        audio.currentTime = duration;
        updateProgress();
      }
    });
  }

  audio.addEventListener('loadedmetadata', resolveDuration);
  audio.addEventListener('durationchange', updateProgress);
  audio.addEventListener('timeupdate', () => {
    if (!seeking) updateProgress();
  });
  audio.addEventListener('play', () => setPlaying(true));
  audio.addEventListener('pause', () => setPlaying(false));
  audio.addEventListener('ended', () => {
    setPlaying(false);
    audio.currentTime = 0;
    updateProgress();
  });
  audio.addEventListener('error', () => setPlaying(false));

  if (audio.readyState >= 1) resolveDuration();
  updateProgress();
}

function k7BoxHeading(el) {
  return (el.querySelector('p, h2, h3, h4, caption, th, strong')?.textContent || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function k7ArticleBoxKind(el) {
  const heading = k7BoxHeading(el);
  if (el.querySelector('table')) return 'table';
  if (/nachteil/.test(heading) || /herausforderung/.test(heading) || /checkliste/.test(heading) || /wärme-check|waerme-check|warme-check/.test(heading)) {
    return 'light';
  }
  return 'dark';
}

function k7LooksBoxed(el) {
  if (!el || !el.matches) return false;
  if (el.matches('aside, table')) return true;
  if (el.querySelector(':scope > table')) return true;
  const style = el.getAttribute('style') || '';
  return /border(?:-left|-right|-top|-bottom)?\s*:/.test(style);
}

function k7LabelTable(table) {
  const headers = Array.from(table.querySelectorAll('thead th')).map((th) =>
    th.textContent.replace(/\s+/g, ' ').trim()
  );
  if (!headers.length) return;
  table.querySelectorAll('tbody tr').forEach((tr) => {
    Array.from(tr.children).forEach((cell, index) => {
      if (headers[index]) cell.setAttribute('data-label', headers[index]);
    });
  });
}

function enhanceK7ArticleBoxes(magazine) {
  magazine.querySelectorAll('[data-k7-article-body]').forEach((body) => {
    Array.from(body.querySelectorAll('div')).forEach((div) => {
      if (div.classList.contains('k7-article-box') || div.classList.contains('k7-article-box-pair')) return;
      const kids = Array.from(div.children);
      if (!kids.length || !kids.every((child) => child.matches('aside'))) return;
      div.replaceWith(...kids);
    });

    const candidates = Array.from(body.querySelectorAll('aside, table, div')).filter((el) => {
      if (el.classList.contains('k7-article-box') || el.classList.contains('k7-article-box-pair')) return false;
      if (el.closest('.k7-article-box')) return false;
      return k7LooksBoxed(el);
    });

    candidates.forEach((el) => {
      if (el.closest('.k7-article-box')) return;

      if (el.matches('table')) {
        const wrap = document.createElement('div');
        wrap.className = 'k7-article-box k7-article-box--table';
        el.parentNode.insertBefore(wrap, el);
        wrap.appendChild(el);
        k7LabelTable(el);
        return;
      }

      const hasTable = !!el.querySelector('table');
      const heading = k7BoxHeading(el);
      const kind = hasTable ? 'table' : k7ArticleBoxKind(el);
      el.classList.add('k7-article-box', `k7-article-box--${kind}`);
      if (/checkliste/.test(heading)) el.classList.add('k7-article-box--checklist');
      if (hasTable) k7LabelTable(el.querySelector('table'));
    });

    const boxes = Array.from(body.querySelectorAll(':scope > .k7-article-box')).filter(
      (el) => !el.classList.contains('k7-article-box--table')
    );
    for (let i = 0; i < boxes.length - 1; i += 1) {
      const current = boxes[i];
      const next = boxes[i + 1];
      if (current.nextElementSibling !== next) continue;
      if (!/vorteil/.test(k7BoxHeading(current))) continue;
      if (!/nachteil|herausforderung/.test(k7BoxHeading(next))) continue;
      const pair = document.createElement('div');
      pair.className = 'k7-article-box-pair';
      current.parentNode.insertBefore(pair, current);
      pair.appendChild(current);
      pair.appendChild(next);
      i += 1;
    }
  });
}

function initK7ArticleMagazine(root = document) {
  const magazines = root.querySelectorAll('[data-k7-article-magazine]');
  magazines.forEach((magazine) => {
    if (magazine.dataset.k7Init === 'true') return;
    magazine.dataset.k7Init = 'true';

    initK7ArticleVoice(magazine);
    enhanceK7ArticleBoxes(magazine);

    const tocs = Array.from(magazine.querySelectorAll('[data-k7-article-toc]'));
    const main = magazine.querySelector('.k7-article-magazine__main');
    if (!tocs.length || !main) return;

    const headingNodes = Array.from(
      main.querySelectorAll('[data-k7-article-body] h2, [data-k7-article-body] h3, .k7-article-magazine__fazit h2, .k7-article-magazine__faq h2')
    ).filter((heading) => !heading.hasAttribute('data-toc-ignore'));

    const chapters = [];
    let current = null;

    headingNodes.forEach((heading) => {
      const title = (heading.getAttribute('data-toc-title') || heading.textContent || '').trim();
      if (!title) return;

      if (!heading.id) {
        const base = k7Slugify(title) || 'section';
        let id = base;
        let i = 2;
        while (document.getElementById(id)) {
          id = `${base}-${i}`;
          i += 1;
        }
        heading.id = id;
      }

      const isSub = heading.tagName === 'H3' && current && current.el.tagName === 'H2';
      if (isSub) {
        current.subs.push({ id: heading.id, title, el: heading });
      } else {
        current = { id: heading.id, title, el: heading, subs: [] };
        chapters.push(current);
      }
    });

    const resolveChapter = (id) => {
      for (const chapter of chapters) {
        if (chapter.id === id) return { chapter, subId: null };
        const sub = chapter.subs.find((item) => item.id === id);
        if (sub) return { chapter, subId: sub.id };
      }
      return null;
    };

    let activeId = null;
    let scrollLocked = false;
    let scrollToken = 0;
    let ticking = false;

    const setActiveToc = (id) => {
      const resolved = resolveChapter(id);
      if (!resolved) return;
      const { chapter, subId } = resolved;

      tocs.forEach((toc) => {
        toc.querySelectorAll('.k7-article-magazine__toc-item').forEach((item) => {
          const active = item.getAttribute('aria-controls') === chapter.id;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-expanded', active && chapter.subs.length ? 'true' : 'false');
        });

        toc.querySelectorAll('.k7-article-magazine__toc-sub a').forEach((link) => {
          link.classList.toggle('is-active', !!subId && link.getAttribute('href') === `#${subId}`);
        });
      });
    };

    const tocPanel = magazine.querySelector('[data-k7-toc-panel]');
    const desktopTocMq = window.matchMedia('(min-width: 1000px)');
    const syncTocPanel = () => {
      if (!tocPanel) return;
      if (desktopTocMq.matches) tocPanel.open = true;
    };
    if (desktopTocMq.addEventListener) {
      desktopTocMq.addEventListener('change', syncTocPanel);
    } else if (desktopTocMq.addListener) {
      desktopTocMq.addListener(syncTocPanel);
    }
    syncTocPanel();

    const navigateToHeading = async (id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const token = ++scrollToken;
      scrollLocked = true;

      if (tocPanel && !desktopTocMq.matches) tocPanel.open = false;

      await k7SmoothScrollTo(el);

      if (token !== scrollToken) return;
      activeId = id;
      setActiveToc(id);
      scrollLocked = false;
    };

    const chevronHtml =
      '<span class="circle-chevron group-hover:colors group-expanded:colors group-expanded:rotate" aria-hidden="true"><svg role="presentation" focusable="false" width="8" height="6" viewBox="0 0 10 7"><path d="m1 1 4 4 4-4" fill="none" stroke="currentColor" stroke-width="2"></path></svg></span>';

    const buildToc = (toc) => {
      toc.innerHTML = '';
      chapters.forEach((chapter, index) => {
        const wrap = document.createElement('div');
        wrap.className = 'k7-article-magazine__toc-group';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'k7-article-magazine__toc-item group';
        button.setAttribute('aria-controls', chapter.id);
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = `<span class="k7-article-magazine__toc-index">${index + 1}</span><span class="k7-article-magazine__toc-label">${chapter.title}</span>${
          chapter.subs.length ? chevronHtml : ''
        }`;
        button.addEventListener('click', () => {
          navigateToHeading(chapter.id);
        });
        wrap.appendChild(button);

        if (chapter.subs.length) {
          const sub = document.createElement('div');
          sub.className = 'k7-article-magazine__toc-sub';
          chapter.subs.forEach((item) => {
            const link = document.createElement('a');
            link.href = `#${item.id}`;
            link.textContent = item.title;
            link.addEventListener('click', (event) => {
              event.preventDefault();
              navigateToHeading(item.id);
            });
            sub.appendChild(link);
          });
          wrap.appendChild(sub);
        }

        toc.appendChild(wrap);
      });
    };

    tocs.forEach(buildToc);

    const headings = [];
    chapters.forEach((chapter) => {
      headings.push(chapter.el);
      chapter.subs.forEach((sub) => headings.push(sub.el));
    });

    const updateActiveFromScroll = () => {
      if (scrollLocked || !headings.length) return;
      const readingLine = window.innerHeight * 0.45;
      let currentId = headings[0].id;

      for (const el of headings) {
        if (el.getBoundingClientRect().top <= readingLine) {
          currentId = el.id;
        } else {
          break;
        }
      }

      if (currentId && currentId !== activeId) {
        activeId = currentId;
        setActiveToc(currentId);
      }
    };

    const onScroll = () => {
      if (scrollLocked || ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateActiveFromScroll();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateActiveFromScroll();

    magazine.querySelectorAll('[data-k7-article-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;
        button.disabled = true;
        try {
          const cartDrawerElement = document.querySelector('cart-drawer');
          const sectionId = cartDrawerElement?.getAttribute('data-section-id') || 'cart-drawer';
          let sectionsToBundle = ['variant-added'];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle }
            })
          );
          if (!sectionsToBundle.includes(sectionId)) sectionsToBundle.push(sectionId);

          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionsToBundle.join(',')
            })
          });
          if (!response.ok) throw new Error('add failed');
          const responseJson = await response.json();
          const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
          if (!responseJson.sections || !responseJson.sections[sectionId]) {
            const cartDrawerResponse = await fetch(`${window.Shopify.routes.root}cart?section_id=${sectionId}`);
            const cartDrawerHtml = await cartDrawerResponse.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cartDrawerHtml;
            const newCartDrawer = tempDiv.querySelector('#cart-drawer');
            if (newCartDrawer) {
              responseJson.sections = responseJson.sections || {};
              responseJson.sections[sectionId] = newCartDrawer.outerHTML;
            }
          }
          cartContent.sections = Object.assign(cartContent.sections || {}, responseJson.sections || {});
          const formToUse = document.querySelector('form[is="product-form"]') || document.createElement('form');
          let formAdded = false;
          if (!formToUse.isConnected) {
            document.body.appendChild(formToUse);
            formAdded = true;
          }
          formToUse.dispatchEvent(
            new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items: responseJson.items || [responseJson],
                cart: cartContent
              }
            })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartContent }
            })
          );
          if (formAdded) document.body.removeChild(formToUse);
        } catch (error) {
          console.error(error);
        } finally {
          button.disabled = false;
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initK7ArticleMagazine());
document.addEventListener('shopify:section:load', (event) => initK7ArticleMagazine(event.target));

/* k7 article magazine end */

/* ========================================
   K7 MOBILE NAV PROMO
   ======================================== */

function initK7MobileNavPromo(root = document) {
  root.querySelectorAll('[data-k7-mobile-nav-promo]').forEach((promo) => {
    if (promo.dataset.k7Init === 'true') return;
    promo.dataset.k7Init = 'true';

    const toggle = promo.querySelector('[data-k7-mobile-nav-promo-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const collapsed = promo.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initK7MobileNavPromo());
document.addEventListener('shopify:section:load', (event) => initK7MobileNavPromo(event.target));

/* k7 mobile nav promo end */

/* ========================================
   K7 FILTERCARD HEIGHT
   ======================================== */

function syncK7FiltercardHeight() {
  const filter = document.querySelector('.collection__facets .k7-filtercard');
  const card = document.querySelector('.collection__results .product-card');

  if (!filter) return;

  if (!card || !window.matchMedia('(min-width: 1000px)').matches) {
    filter.style.removeProperty('--k7-filtercard-match-height');
    return;
  }

  const height = Math.round(card.getBoundingClientRect().height);
  if (height > 0) {
    filter.style.setProperty('--k7-filtercard-match-height', `${height}px`);
  }
}

function initK7FiltercardHeight(root = document) {
  syncK7FiltercardHeight();

  const section =
    root.querySelector?.('.shopify-section--main-collection, .shopify-section--main-search') ||
    (root.matches?.('.shopify-section--main-collection, .shopify-section--main-search') ? root : null) ||
    document.querySelector('.shopify-section--main-collection, .shopify-section--main-search');

  if (section && section.dataset.k7FiltercardObserve !== 'true') {
    section.dataset.k7FiltercardObserve = 'true';
    const sectionObserver = new MutationObserver(() => {
      requestAnimationFrame(initK7FiltercardHeight);
    });
    sectionObserver.observe(section, { childList: true });
  }

  const card = document.querySelector('.collection__results .product-card');
  if (!card) return;

  if (window.k7FiltercardResizeObserver) {
    window.k7FiltercardResizeObserver.disconnect();
  }

  window.k7FiltercardResizeObserver = new ResizeObserver(() => {
    syncK7FiltercardHeight();
  });
  window.k7FiltercardResizeObserver.observe(card);
}

document.addEventListener('DOMContentLoaded', () => initK7FiltercardHeight());
document.addEventListener('shopify:section:load', (event) => initK7FiltercardHeight(event.target));
window.addEventListener('resize', syncK7FiltercardHeight);

/* k7 filtercard height end */

/* ========================================
   K7 GLOSSAR
   ======================================== */

function k7GlossarNormalize(value) {
  return (value || '')
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');
}

function initK7Glossar(root = document) {
  root.querySelectorAll('[data-k7-glossar]').forEach((glossar) => {
    if (glossar.dataset.k7Init === 'true') return;
    glossar.dataset.k7Init = 'true';

    const buttons = glossar.querySelectorAll('[data-k7-glossar-letter]');
    const items = glossar.querySelectorAll('[data-k7-glossar-item]');
    const search = glossar.querySelector('[data-k7-glossar-search]');
    const empty = glossar.querySelector('[data-k7-glossar-empty]');
    if (!buttons.length || !items.length) return;

    let activeLetter = 'all';

    const applyFilters = () => {
      const query = k7GlossarNormalize(search ? search.value : '').trim();
      let visible = 0;

      items.forEach((item) => {
        const letterMatch = activeLetter === 'all' || item.dataset.letter === activeLetter;
        const searchMatch = !query || k7GlossarNormalize(item.dataset.search || '').includes(query);
        const show = letterMatch && searchMatch;
        item.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible > 0;
    };

    const activate = (letter) => {
      activeLetter = letter || 'all';
      buttons.forEach((button) => {
        const active = button.dataset.k7GlossarLetter === activeLetter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      applyFilters();
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.k7GlossarLetter));
    });

    search?.addEventListener('input', applyFilters);
    search?.form?.addEventListener('reset', () => {
      requestAnimationFrame(applyFilters);
    });

    const params = new URLSearchParams(window.location.search);
    const initialLetter = (params.get('letter') || '').toUpperCase();
    const initialQuery = params.get('q') || '';
    if (search && initialQuery) search.value = initialQuery;
    if (initialLetter && initialLetter !== 'ALL') {
      activate(initialLetter);
    } else {
      applyFilters();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initK7Glossar());
document.addEventListener('shopify:section:load', (event) => initK7Glossar(event.target));

function k7GlossarTermParts(entry) {
  const parts = [];
  const push = (value) => {
    String(value || '')
      .split(/[,/;|]+/)
      .forEach((part) => {
        const term = part.trim();
        if (term.length >= 3) parts.push(term);
      });
  };
  push(entry.title);
  push(entry.inci);
  push(entry.synonyms);
  return [...new Set(parts)];
}

function initK7GlossarLinks(root = document) {
  const source = root.querySelector('[data-k7-glossar-terms]') || document.querySelector('[data-k7-glossar-terms]');
  if (!source) return;

  let entries = [];
  try {
    entries = JSON.parse(source.textContent || '[]');
  } catch (error) {
    return;
  }

  const dictionary = [];
  entries.forEach((entry) => {
    if (!entry || !entry.url) return;
    k7GlossarTermParts(entry).forEach((term) => {
      dictionary.push({ term, url: entry.url });
    });
  });
  dictionary.sort((a, b) => b.term.length - a.term.length);
  if (!dictionary.length) return;

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const pattern = new RegExp(
    `(?<![A-Za-z0-9ÄÖÜäöüß])(${dictionary.map((item) => escapeRegExp(item.term)).join('|')})(?![A-Za-z0-9ÄÖÜäöüß])`,
    'gi'
  );
  const urlByTerm = new Map(dictionary.map((item) => [item.term.toLowerCase(), item.url]));
  const newTabLabel = source.dataset.k7GlossarNewTab || '';

  const scopes = root.querySelectorAll('.product-info .prose, .product-info .k7-inhaltsstoffe');

  scopes.forEach((scope) => {
    if (scope.dataset.k7GlossarLinked === 'true') return;
    scope.dataset.k7GlossarLinked = 'true';

    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest('a, script, style, noscript')) return NodeFilter.FILTER_REJECT;
        const matches = pattern.test(node.nodeValue || '');
        pattern.lastIndex = 0;
        if (!matches) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const text = node.nodeValue;
      pattern.lastIndex = 0;
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;

      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      text.replace(pattern, (match, _term, offset) => {
        if (offset > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
        }
        const url = urlByTerm.get(match.toLowerCase());
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.className = 'k7-glossar-link';
          link.target = '_blank';
          link.rel = 'noopener';
          link.appendChild(document.createTextNode(match));
          if (newTabLabel) {
            const hint = document.createElement('span');
            hint.className = 'sr-only';
            hint.textContent = ` (${newTabLabel})`;
            link.appendChild(hint);
          }
          fragment.appendChild(link);
        } else {
          fragment.appendChild(document.createTextNode(match));
        }
        lastIndex = offset + match.length;
        return match;
      });
      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }
      node.parentNode.replaceChild(fragment, node);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initK7GlossarLinks());
document.addEventListener('shopify:section:load', (event) => initK7GlossarLinks(event.target));

/* k7 cart discount start */

class K7CartDiscount extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;
    this.isLoading = false;
    this.isRemoving = false;

    this.input = this.querySelector('.k7-cart-discount__input');
    this.submitButton = this.querySelector('.k7-cart-discount__button');
    this.errorContainer = this.querySelector('.k7-cart-discount__error');
    this.errorText = this.querySelector('.k7-cart-discount__error-text');
    this.codesContainer = this.querySelector('.k7-cart-discount__codes');

    this.submitButton?.addEventListener('click', (event) => {
      event.preventDefault();
      this.handleSubmit();
    });

    this.input?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.handleSubmit();
    });

    this.addEventListener('click', (event) => {
      const removeButton = event.target.closest('.k7-cart-discount__remove');
      if (!removeButton || !this.contains(removeButton)) return;
      event.preventDefault();
      event.stopPropagation();
      this.handleRemoveDiscount(removeButton);
    });

    this._onCartChange = (event) => {
      if (event?.detail?.baseEvent === 'discount:apply' || event?.detail?.baseEvent === 'discount:remove') return;
      this.syncBadgesFromCart(event?.detail?.cart);
    };
    document.addEventListener('cart:change', this._onCartChange);
  }

  disconnectedCallback() {
    if (this._onCartChange) {
      document.removeEventListener('cart:change', this._onCartChange);
    }
  }

  getDiscountStrings() {
    return {
      invalid: this.dataset.msgInvalid || 'Der Rabattcode ist ungültig.',
      notCombinable: this.dataset.msgNotCombinable || 'Dieser Rabattcode kann nicht kombiniert werden.',
      samePercent: this.dataset.msgSamePercent || 'Es ist bereits ein Rabatt von {percent} % aktiv. Dieser Code bietet denselben Rabatt und wird daher nicht angewendet.',
      higherPercent: this.dataset.msgHigherPercent || 'Es ist bereits ein höherer Rabatt von {percent} % aktiv. Dieser Code wird daher nicht angewendet.',
      checkoutOnly: this.dataset.msgCheckoutOnly || 'Dieser Rabattcode muss beim Bezahlen eingegeben werden.',
      generic: this.dataset.msgGeneric || 'Der Rabattcode konnte nicht angewendet werden.'
    };
  }

  getDiscountErrorMessage(apiMessage, code) {
    const strings = this.getDiscountStrings();
    const normalized = (apiMessage || '').toLowerCase().trim();

    if (normalized.includes('checkout')) return strings.checkoutOnly;

    if (
      normalized.includes('not valid') ||
      normalized.includes('invalid') ||
      normalized.includes('ungültig') ||
      normalized.includes('does not exist') ||
      normalized.includes('could not be found')
    ) {
      return strings.invalid;
    }

    if (
      normalized.includes('combine') ||
      normalized.includes('combin') ||
      normalized.includes('already applied') ||
      normalized.includes('cannot be used')
    ) {
      return strings.notCombinable;
    }

    return apiMessage || strings.generic;
  }

  codePercentFromCode(code) {
    const match = String(code || '').trim().match(/[a-zA-Z](\d{1,2})$/);
    if (!match) return null;
    const percent = parseInt(match[1], 10);
    if (percent < 1 || percent > 40) return null;
    return percent;
  }

  isGiftCartLine(item) {
    return Boolean(item?.properties?._k7_gift);
  }

  discountPercentFromAllocation(item, allocation) {
    const application = allocation?.discount_application || {};
    if (application.type === 'discount_code') return null;

    if (application.value_type === 'percentage') {
      const value = parseFloat(application.value);
      return Number.isFinite(value) ? value : null;
    }

    const base = item?.original_line_price || 0;
    if (base > 0 && allocation?.amount > 0) {
      return (allocation.amount / base) * 100;
    }

    return null;
  }

  messageForExistingPercentDiscount(cart, code) {
    const codePercent = this.codePercentFromCode(code);
    if (!codePercent) return null;

    let best = 0;
    (cart?.items || []).forEach((item) => {
      if (this.isGiftCartLine(item)) return;
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const percent = this.discountPercentFromAllocation(item, allocation);
        if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return;
        best = Math.max(best, Math.round(percent));
      });
    });

    if (!best || best < codePercent) return null;

    const strings = this.getDiscountStrings();
    const template = best === codePercent ? strings.samePercent : strings.higherPercent;
    if (!template) return null;
    return template.replace(/\{percent\}/g, String(best));
  }

  showDiscountError(message) {
    if (this.errorText) this.errorText.textContent = message;
    this.errorContainer?.classList.remove('k7-cart-discount__error--hidden');
    this.input?.classList.add('k7-cart-discount__input--error');
    this.input?.classList.remove('k7-cart-discount__input--success');
  }

  hideDiscountError() {
    this.errorContainer?.classList.add('k7-cart-discount__error--hidden');
    if (this.errorText) this.errorText.textContent = '';
    this.input?.classList.remove('k7-cart-discount__input--error');
  }

  setLoading(loading) {
    this.isLoading = loading;
    if (!this.submitButton) return;
    this.submitButton.disabled = loading;
    if (loading) {
      this.submitButton.setAttribute('aria-busy', 'true');
    } else {
      this.submitButton.removeAttribute('aria-busy');
    }
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  showDiscountAppliedAnnouncement(code) {
    document.querySelectorAll('.k7-cart-discount-toast').forEach((toast) => toast.remove());

    const template = this.dataset.msgApplied || 'Rabattcode {code} wurde angewendet';
    const toast = document.createElement('div');
    toast.className = 'k7-cart-discount-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = template.replace(/\{code\}/gi, code);
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    window.clearTimeout(this._toastTimeout);
    this._toastTimeout = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => toast.remove(), 350);
    }, 3500);
  }

  getAppliedCodesFromCart(cart) {
    const codes = [];
    const seen = new Set();

    const pushCode = (code) => {
      const trimmed = (code || '').trim();
      if (!trimmed) return;
      const key = trimmed.toUpperCase();
      if (seen.has(key)) return;
      seen.add(key);
      codes.push(trimmed);
    };

    (cart?.discount_codes || []).forEach((entry) => {
      if (entry?.applicable === false) return;
      pushCode(entry?.code);
    });

    (cart?.cart_level_discount_applications || []).forEach((application) => {
      if (application?.type === 'discount_code') pushCode(application.title);
    });

    (cart?.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const application = allocation?.discount_application;
        if (application?.type === 'discount_code') pushCode(application.title);
      });
    });

    return codes;
  }

  renderDiscountBadge(code) {
    const removeLabel = this.escapeHtml(this.dataset.msgRemove || 'Rabatt entfernen');
    return `
      <div class="badge discount-badge" data-discount-code="${this.escapeHtml(code)}">
        <span>${this.escapeHtml(code)}</span>
        <button type="button" class="k7-cart-discount__remove" aria-label="${removeLabel}">
          <span aria-hidden="true">×</span>
        </button>
      </div>
    `;
  }

  syncBadges(codes) {
    if (!this.codesContainer) this.codesContainer = this.querySelector('.k7-cart-discount__codes');
    if (!this.codesContainer) return;
    const nextCodes = Array.isArray(codes) ? codes.filter(Boolean) : [];
    this.codesContainer.innerHTML = nextCodes.map((code) => this.renderDiscountBadge(code)).join('');
    this.codesContainer.hidden = nextCodes.length === 0;
  }

  async syncBadgesFromCart(cart) {
    try {
      let nextCart = cart;
      if (!nextCart || (!nextCart.discount_codes && !nextCart.cart_level_discount_applications)) {
        nextCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      }
      this.syncBadges(this.getAppliedCodesFromCart(nextCart));
    } catch (error) {
      console.error('Failed to sync discount badges:', error);
    }
  }

  getSectionsToBundle() {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    if (sectionsToBundle.length === 0) {
      const cartDrawer = document.getElementById('cart-drawer');
      const sectionId = cartDrawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '')
        || this.dataset.sectionId
        || 'cart-drawer';
      sectionsToBundle.push(sectionId);
    }

    return sectionsToBundle;
  }

  isDiscountCodeApplied(cartData, discountCode) {
    const normalizedCode = discountCode.toUpperCase();
    const codeEntry = (cartData.discount_codes || []).find(
      (entry) => (entry.code || '').toUpperCase() === normalizedCode
    );
    if (codeEntry) return codeEntry.applicable === true;
    return (cartData.cart_level_discount_applications || []).some(
      (application) => application.type === 'discount_code' && (application.title || '').toUpperCase() === normalizedCode
    );
  }

  async ensureSections(cartData, sectionsToBundle) {
    if (!cartData.sections) cartData.sections = {};
    for (const sectionId of sectionsToBundle) {
      if (cartData.sections[sectionId]) continue;
      const response = await fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`);
      if (!response.ok) continue;
      cartData.sections[sectionId] = await response.text();
    }
    return cartData;
  }

  dispatchCartChange(cartData, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent,
        cart: cartData
      }
    }));
  }

  async handleRemoveDiscount(button) {
    if (this.isRemoving || this.isLoading) return;
    const badge = button.closest('.discount-badge');
    const discountCode = badge?.dataset.discountCode;
    if (!discountCode) return;

    this.isRemoving = true;
    button.disabled = true;

    try {
      const sectionsToBundle = this.getSectionsToBundle();
      const currentCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      const remainingCodes = (currentCart.discount_codes || [])
        .map((entry) => entry.code)
        .filter((code) => code && code.toUpperCase() !== discountCode.toUpperCase());

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: remainingCodes.join(','),
          sections: sectionsToBundle
        })
      });

      if (!response.ok) throw new Error('Failed to remove discount');

      let cartData = await response.json();
      cartData = await this.ensureSections(cartData, sectionsToBundle);
      this.syncBadges(this.getAppliedCodesFromCart(cartData));
      this.dispatchCartChange(cartData, 'discount:remove');

      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
      }
    } catch (error) {
      console.error('Failed to remove discount:', error);
      button.disabled = false;
      await this.syncBadgesFromCart(null);
    } finally {
      this.isRemoving = false;
    }
  }

  async handleSubmit() {
    if (!this.input || this.isLoading) return;
    const discountCode = this.input.value.trim();
    if (!discountCode) return;

    this.setLoading(true);
    this.hideDiscountError();
    this.input.classList.remove('k7-cart-discount__input--success');

    try {
      const sectionsToBundle = this.getSectionsToBundle();
      const currentCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      const existingCodes = (currentCart.discount_codes || []).map((entry) => entry.code).filter(Boolean);
      const alreadyPresent = existingCodes.some((code) => code.toUpperCase() === discountCode.toUpperCase());
      const discountPayload = alreadyPresent ? existingCodes.join(',') : [...existingCodes, discountCode].join(',');

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: discountPayload,
          sections: sectionsToBundle
        })
      });

      let cartData = await response.json();

      if (!response.ok) {
        this.showDiscountError(this.getDiscountErrorMessage(cartData.description || cartData.message, discountCode));
        return;
      }

      if (!this.isDiscountCodeApplied(cartData, discountCode)) {
        const codeEntry = (cartData.discount_codes || []).find(
          (entry) => (entry.code || '').toUpperCase() === discountCode.toUpperCase()
        );
        const existingDiscountMessage = this.messageForExistingPercentDiscount(cartData, discountCode);
        this.showDiscountError(
          existingDiscountMessage
            || (codeEntry && codeEntry.applicable === false
              ? this.getDiscountStrings().notCombinable
              : this.getDiscountErrorMessage(null, discountCode))
        );
        return;
      }

      cartData = await this.ensureSections(cartData, sectionsToBundle);
      this.input.value = '';
      this.input.classList.add('k7-cart-discount__input--success');
      this.syncBadges(this.getAppliedCodesFromCart(cartData));
      this.showDiscountAppliedAnnouncement(discountCode);
      this.dispatchCartChange(cartData, 'discount:apply');

      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
      }
    } catch (error) {
      console.error('Failed to apply discount:', error);
      this.showDiscountError(this.getDiscountErrorMessage(null, discountCode));
    } finally {
      this.setLoading(false);
    }
  }
}

if (!window.customElements.get('k7-cart-discount')) {
  window.customElements.define('k7-cart-discount', K7CartDiscount);
}

/* k7 cart discount end */

/* ========================================
   K7 LIST ROLES
   ======================================== */

function k7ExposeLists(root = document) {
  root.querySelectorAll('ul, ol').forEach((list) => {
    const items = list.querySelectorAll(':scope > li');
    const needsListRole = list.classList.contains('contents') || items.length > 0 && Array.from(items).some((item) => item.classList.contains('contents'));

    if (!needsListRole && list.getAttribute('role') !== 'list') return;

    if (!list.getAttribute('role')) list.setAttribute('role', 'list');

    items.forEach((item) => {
      if (!item.getAttribute('role')) item.setAttribute('role', 'listitem');
    });
  });
}

k7ExposeLists();
document.addEventListener('shopify:section:load', (event) => k7ExposeLists(event.target));

/* k7-footer-menu-radius start */
function k7CssVarPx(name) {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  if (raw.endsWith('rem')) {
    return parseFloat(raw) * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
  return parseFloat(raw) || 0;
}

function syncK7FooterMenuRadius(accordion) {
  const summary = accordion.querySelector('summary');
  if (!summary) return;

  const collapsedHeight = summary.getBoundingClientRect().height;
  const currentHeight = accordion.getBoundingClientRect().height;
  const fullHeight = Math.max(accordion.scrollHeight, currentHeight);
  const span = fullHeight - collapsedHeight;
  const progress = span > 1 ? Math.min(1, Math.max(0, (currentHeight - collapsedHeight) / span)) : 0;
  const pillRadius = Math.min(accordion._k7CollapsedRadius, collapsedHeight / 2);
  const radius = pillRadius + (accordion._k7ExpandedRadius - pillRadius) * progress;

  accordion.style.borderRadius = `${radius}px`;
}

function initK7FooterMenuRadius(root = document) {
  const collapsedRadius = k7CssVarPx('--rounded-button');
  const expandedRadius = k7CssVarPx('--rounded');

  root.querySelectorAll('.k7-footer-menu.accordion').forEach((accordion) => {
    if (accordion.dataset.k7RadiusInit === 'true') return;
    accordion.dataset.k7RadiusInit = 'true';
    accordion._k7CollapsedRadius = collapsedRadius || 60;
    accordion._k7ExpandedRadius = expandedRadius || 12;

    const summary = accordion.querySelector('summary');
    const sync = () => syncK7FooterMenuRadius(accordion);
    sync();

    if (summary) {
      summary.addEventListener('click', () => {
        let lastHeight = -1;
        let stableFrames = 0;

        const step = () => {
          sync();
          const height = accordion.getBoundingClientRect().height;
          if (Math.abs(height - lastHeight) < 0.5) stableFrames += 1;
          else stableFrames = 0;
          lastHeight = height;
          if (stableFrames < 6) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
      });
    }

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(sync);
      observer.observe(accordion);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initK7FooterMenuRadius());
document.addEventListener('shopify:section:load', (event) => initK7FooterMenuRadius(event.target));
/* k7-footer-menu-radius end */

/* k7 einzelpreis start */
function k7EinzelpreisHoverable() {
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

function k7EinzelpreisDialogMode() {
  return window.matchMedia('(max-width: 699px), (hover: none), (pointer: coarse)').matches;
}

function k7EinzelpreisDialog() {
  let dialog = document.querySelector('.k7-einzelpreis-dialog');
  if (dialog) return dialog;

  dialog = document.createElement('dialog');
  dialog.className = 'k7-einzelpreis-dialog';
  dialog.setAttribute('aria-label', 'Hinweis zum Einzelpreis');
  dialog.innerHTML = '<button type="button" class="k7-einzelpreis-dialog__close"><svg role="presentation" stroke-width="2" focusable="false" width="12" height="12" viewBox="0 0 24 24"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path></svg></button><div class="k7-einzelpreis-dialog__content text-sm"></div>';
  dialog.querySelector('.k7-einzelpreis-dialog__close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  document.body.appendChild(dialog);
  return dialog;
}

function k7OpenEinzelpreisDialog(mark) {
  const tip = k7EinzelpreisTip(mark);
  if (!tip) return;

  const dialog = k7EinzelpreisDialog();
  const close = dialog.querySelector('.k7-einzelpreis-dialog__close');
  close.setAttribute('aria-label', mark.getAttribute('data-close-label') || 'Schließen');

  const content = dialog.querySelector('.k7-einzelpreis-dialog__content');
  content.replaceChildren();
  tip.querySelectorAll(':scope > span').forEach((line) => content.appendChild(line.cloneNode(true)));
  if (!dialog.open) dialog.showModal();
}

function k7EinzelpreisTip(mark) {
  if (mark._k7Tip && mark._k7Tip.isConnected) return mark._k7Tip;
  const tip = mark.querySelector('.k7-einzelpreis__tip');
  if (tip) mark._k7Tip = tip;
  return tip;
}

function k7ShowEinzelpreis(mark) {
  const tip = k7EinzelpreisTip(mark);
  if (!tip) return;

  document.body.appendChild(tip);
  tip.classList.add('is-visible');

  const margin = 12;
  const markRect = mark.getBoundingClientRect();
  tip.style.left = '0px';
  tip.style.top = '0px';
  const tipRect = tip.getBoundingClientRect();
  let left = markRect.left;
  let top = markRect.top - tipRect.height - 8;

  if (left + tipRect.width > window.innerWidth - margin) {
    left = window.innerWidth - margin - tipRect.width;
  }
  if (left < margin) left = margin;
  if (top < margin) top = markRect.bottom + 8;

  tip.style.left = `${left}px`;
  tip.style.top = `${top}px`;
}

function k7HideEinzelpreis(mark) {
  const tip = mark._k7Tip;
  if (!tip) return;
  tip.classList.remove('is-visible');
  mark.appendChild(tip);
}

function k7CloseEinzelpreis(except) {
  document.querySelectorAll('.k7-einzelpreis.is-open').forEach((open) => {
    if (open === except) return;
    open.classList.remove('is-open');
    open.setAttribute('aria-expanded', 'false');
    k7HideEinzelpreis(open);
  });
}

document.addEventListener('mouseover', (event) => {
  const mark = event.target.closest('.k7-einzelpreis');
  if (!mark || !k7EinzelpreisHoverable() || k7EinzelpreisDialogMode() || mark.contains(event.relatedTarget)) return;
  k7ShowEinzelpreis(mark);
});

document.addEventListener('mouseout', (event) => {
  const mark = event.target.closest('.k7-einzelpreis');
  if (!mark || !k7EinzelpreisHoverable() || k7EinzelpreisDialogMode() || mark.contains(event.relatedTarget)) return;
  if (mark.classList.contains('is-open')) return;
  k7HideEinzelpreis(mark);
});

document.addEventListener('click', (event) => {
  if (event.target.closest('.k7-einzelpreis-dialog')) return;

  const mark = event.target.closest('.k7-einzelpreis');

  if (k7EinzelpreisDialogMode()) {
    if (!mark) return;
    event.preventDefault();
    event.stopPropagation();
    k7OpenEinzelpreisDialog(mark);
    return;
  }

  k7CloseEinzelpreis(mark);
  if (!mark) return;

  event.preventDefault();
  event.stopPropagation();

  const open = mark.classList.toggle('is-open');
  mark.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open) k7ShowEinzelpreis(mark);
  else k7HideEinzelpreis(mark);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  k7CloseEinzelpreis(null);
});
/* k7 einzelpreis end */

/* k7 timer start */
function k7ParseTimerDate(dateString) {
  if (!dateString || dateString.trim() === '') return null;

  const trimmed = dateString.trim();

  if (/Z$|[+-]\d{2}:\d{2}$|[+-]\d{4}$|\sUTC$/i.test(trimmed)) {
    const utcDate = new Date(trimmed);
    if (!isNaN(utcDate.getTime())) return utcDate.getTime();
  }

  const yyyyFormat = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/;
  const isoLocalFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/;
  const ddFormat = /^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/;
  let match;

  const build = (year, month, day, hour, minute, second) => {
    const date = new Date(year, month, day, hour, minute, second);
    return isNaN(date.getTime()) ? null : date.getTime();
  };

  if ((match = trimmed.match(yyyyFormat))) {
    return build(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], match[6] ? +match[6] : 0);
  }
  if ((match = trimmed.match(isoLocalFormat))) {
    return build(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], match[6] ? +match[6] : 0);
  }
  if ((match = trimmed.match(ddFormat))) {
    return build(+match[3], +match[2] - 1, +match[1], +match[4], +match[5], match[6] ? +match[6] : 0);
  }

  const parsed = new Date(trimmed);
  return isNaN(parsed.getTime()) ? null : parsed.getTime();
}

function initK7Timer(timerElement) {
  const daysEl = timerElement.querySelector('.k7-timer__days');
  const hoursEl = timerElement.querySelector('.k7-timer__hours');
  const minutesEl = timerElement.querySelector('.k7-timer__minutes');
  const secondsEl = timerElement.querySelector('.k7-timer__seconds');
  const fill = timerElement.querySelector('.k7-timer__fill');
  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  const endTime = k7ParseTimerDate(timerElement.getAttribute('data-metaobject-date') || '');
  const startTime = k7ParseTimerDate(timerElement.getAttribute('data-metaobject-start-date') || '');
  if (endTime == null) return;

  const update = () => {
    const now = Date.now();
    let remaining = Math.max(0, Math.floor((endTime - now) / 1000));
    const total = remaining;
    daysEl.textContent = Math.floor(remaining / 86400);
    remaining %= 86400;
    hoursEl.textContent = Math.floor(remaining / 3600);
    remaining %= 3600;
    minutesEl.textContent = Math.floor(remaining / 60);
    secondsEl.textContent = remaining % 60;

    if (fill && startTime != null && endTime > startTime) {
      const duration = Math.floor((endTime - startTime) / 1000);
      const elapsed = Math.max(0, Math.floor((now - startTime) / 1000));
      const left = Math.max(0, duration - elapsed);
      const progress = elapsed <= duration ? (left / duration) * 100 : 0;
      fill.style.width = `${Math.min(100, Math.max(0, progress))}%`;
    }

    if (total <= 0) {
      const intervalId = timerElement.dataset.intervalId;
      if (intervalId) {
        clearInterval(parseInt(intervalId, 10));
        delete timerElement.dataset.intervalId;
      }
      const hideTarget = timerElement.closest('.product-info__block-item') || timerElement.closest('.k7-timer');
      if (hideTarget) hideTarget.hidden = true;
    }
  };

  update();
  if (Math.max(0, Math.floor((endTime - Date.now()) / 1000)) > 0) {
    timerElement.dataset.intervalId = String(setInterval(update, 1000));
  }
}

function initK7Timers(root = document) {
  root.querySelectorAll('.k7-timer__clock').forEach((timer) => {
    if (timer.dataset.intervalId) {
      clearInterval(parseInt(timer.dataset.intervalId, 10));
      delete timer.dataset.intervalId;
    }
    initK7Timer(timer);
  });
}

function initK7TimerCopy() {
  if (document.documentElement.dataset.k7TimerCopy === 'true') return;
  document.documentElement.dataset.k7TimerCopy = 'true';

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.k7-timer__badge');
    if (!button) return;
    const code = button.getAttribute('data-code');
    const textEl = button.querySelector('.k7-timer__badge-text');
    if (!code || !textEl) return;
    const original = textEl.textContent;

    const showCopied = () => {
      textEl.textContent = 'Kopiert!';
      window.setTimeout(() => {
        textEl.textContent = original;
      }, 2000);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(showCopied).catch(() => {});
      return;
    }

    const field = document.createElement('textarea');
    field.value = code;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '-9999px';
    document.body.appendChild(field);
    field.select();
    try {
      if (document.execCommand('copy')) showCopied();
    } catch (error) {
      console.error(error);
    }
    field.remove();
  });
}

function bootK7Timers() {
  initK7Timers();
  initK7TimerCopy();
  document.querySelectorAll('form[is="product-form"], form[id^="product-form"]').forEach((form) => {
    if (form.dataset.k7TimerRerender === 'true') return;
    form.dataset.k7TimerRerender = 'true';
    form.addEventListener('product:rerender', () => {
      window.setTimeout(initK7Timers, 100);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootK7Timers);
} else {
  bootK7Timers();
}

document.addEventListener('shopify:section:load', (event) => {
  window.setTimeout(() => initK7Timers(event.target || document), 100);
});
/* k7 timer end */

/* k7 strike price start */
function k7StrikeBase(root) {
  const scope = root.closest('.product-info') || document;
  const wrap = scope.querySelector('[data-k7-quantity-presets]');

  if (wrap) {
    const card = wrap.querySelector('[data-k7-quantity-preset].is-selected') || wrap.querySelector('[data-k7-quantity-preset]');
    const unit = parseInt(wrap.getAttribute('data-unit-price'), 10);
    if (card && !Number.isNaN(unit)) {
      const discount = parseInt(card.getAttribute('data-discount'), 10) || 0;
      const paid = parseInt(card.getAttribute('data-paid-qty'), 10) || 1;
      const format = wrap.getAttribute('data-money-format') || root.getAttribute('data-k7-money-format') || '';
      if (wrap.hasAttribute('data-k7-double')) {
        return { cents: unit * paid, format };
      }
      const unitCut = Math.floor((unit * discount) / 100);
      return { cents: (unit - unitCut) * paid, format };
    }
  }

  const dataEl = root.querySelector('[data-k7-strike-variants]');
  let variants = {};
  try {
    variants = JSON.parse(dataEl ? dataEl.textContent : '{}');
  } catch (error) {
    variants = {};
  }
  const idInput = scope.querySelector('[name="id"]');
  const price = variants[idInput ? String(idInput.value) : ''];
  if (typeof price !== 'number') return null;
  return { cents: price, format: root.getAttribute('data-k7-money-format') || '' };
}

function renderK7Strike(root) {
  const disc = parseInt(root.getAttribute('data-k7-discount'), 10) || 0;
  const base = k7StrikeBase(root);
  if (!base) return;
  const cut = Math.floor((base.cents * disc) / 100);
  const newEl = root.querySelector('[data-k7-strike-new]');
  const oldEl = root.querySelector('[data-k7-strike-old]');
  if (newEl) newEl.textContent = k7FormatMoney(base.cents - cut, base.format);
  if (oldEl) oldEl.textContent = k7FormatMoney(base.cents, base.format);
}

function copyK7Strike(button) {
  const code = button.getAttribute('data-k7-code');
  if (!code) return;

  const showCopied = () => {
    if (button._k7CopyTimer) window.clearTimeout(button._k7CopyTimer);
    button.classList.add('is-copied');
    button._k7CopyTimer = window.setTimeout(() => {
      button.classList.remove('is-copied');
    }, 2000);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(code).then(showCopied).catch(() => {});
    return;
  }

  const field = document.createElement('textarea');
  field.value = code;
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.top = '-9999px';
  document.body.appendChild(field);
  field.select();
  try {
    if (document.execCommand('copy')) showCopied();
  } catch (error) {
    console.error(error);
  }
  field.remove();
}

function bootK7Strike() {
  if (document.documentElement.dataset.k7Strike === 'true') return;
  document.documentElement.dataset.k7Strike = 'true';

  const renderAll = () => {
    document.querySelectorAll('[data-k7-strike]').forEach(renderK7Strike);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.k7-strike__box');
    if (button) {
      const root = button.closest('[data-k7-strike]');
      if (root) copyK7Strike(root);
      return;
    }
    if (event.target.closest('[data-k7-quantity-preset]')) renderAll();
  });

  document.addEventListener('variant:change', renderAll);
  document.addEventListener('product:rerender', () => window.setTimeout(renderAll, 100), true);
  document.addEventListener('shopify:section:load', (event) => {
    window.setTimeout(() => {
      (event.target || document).querySelectorAll('[data-k7-strike]').forEach(renderK7Strike);
    }, 100);
  });

  renderAll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootK7Strike);
} else {
  bootK7Strike();
}
/* k7 strike price end */

/* k7 probenpaket start */
function k7IsProbenpaketItem(item) {
  const key = `${item?.handle || ''} ${item?.product_title || ''} ${item?.title || ''}`.toLowerCase();
  return key.includes('probenpaket');
}

let k7ProbenpaketClamping = false;

async function k7EnforceProbenpaketLimit(cart) {
  if (k7ProbenpaketClamping || !cart?.items) return;

  const groups = new Map();
  cart.items.filter(k7IsProbenpaketItem).forEach((line) => {
    const id = String(line.variant_id);
    if (!groups.has(id)) groups.set(id, []);
    groups.get(id).push(line);
  });

  const updates = {};
  groups.forEach((lines) => {
    let remaining = 1;
    lines.forEach((line) => {
      const next = Math.min(line.quantity || 0, remaining);
      if (next !== line.quantity) updates[line.key] = next;
      remaining -= next;
    });
  });
  if (!Object.keys(updates).length) return;

  k7ProbenpaketClamping = true;
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) return;
    const updated = await response.json();
    const counts = {};
    (updated.items || []).filter(k7IsProbenpaketItem).forEach((line) => {
      const id = String(line.variant_id);
      counts[id] = (counts[id] || 0) + (line.quantity || 0);
    });
    if (Object.values(counts).some((count) => count > 1)) return;
    if (window.themeVariables?.settings?.pageType === 'cart') {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  } finally {
    k7ProbenpaketClamping = false;
  }
}

function k7BootProbenpaketLimit() {
  if (document.documentElement.dataset.k7Probenpaket === 'true') return;
  document.documentElement.dataset.k7Probenpaket = 'true';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[data-k7-one-per-order]')) return;
    if (form.dataset.k7OnePerOrderChecked === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const variantId = String(form.querySelector('[name="id"]')?.value || '');
        const alreadyInCart = (cart.items || []).some((item) => {
          return k7IsProbenpaketItem(item) && String(item.variant_id) === variantId && item.quantity >= 1;
        });
        if (variantId && alreadyInCart) {
          if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
            window.location.href = `${window.Shopify.routes.root}cart`;
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.querySelector('cart-drawer')?.show?.();
          return;
        }
        form.dataset.k7OnePerOrderChecked = 'true';
        form.requestSubmit();
        delete form.dataset.k7OnePerOrderChecked;
      })
      .catch(() => {
        form.dataset.k7OnePerOrderChecked = 'true';
        form.requestSubmit();
        delete form.dataset.k7OnePerOrderChecked;
      });
  }, true);

  document.addEventListener('cart:change', (event) => {
    k7EnforceProbenpaketLimit(event.detail?.cart);
  });

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((cart) => k7EnforceProbenpaketLimit(cart))
    .catch(() => {});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', k7BootProbenpaketLimit);
} else {
  k7BootProbenpaketLimit();
}

/* ========================================
   K7 ACCOUNT AVATAR
   ======================================== */

function k7FitAccountAvatar(account) {
  const shadow = account.shadowRoot;
  if (!shadow || shadow.getElementById('k7-account-avatar-size')) return;

  const style = document.createElement('style');
  style.id = 'k7-account-avatar-size';
  style.textContent = '.account-button{--clamped-avatar-size:44px !important}';
  shadow.appendChild(style);
}

function k7BootAccountAvatar() {
  const fit = () => {
    document.querySelectorAll('.k7-header shopify-account').forEach(k7FitAccountAvatar);
  };

  fit();
  customElements.whenDefined('shopify-account').then(fit);
  document.addEventListener('shopify-render', fit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', k7BootAccountAvatar);
} else {
  k7BootAccountAvatar();
}
/* k7 probenpaket end */

/* k7 feuchttuecher double start */
function k7EvenWipesQuantity(quantity) {
  const count = parseInt(quantity, 10) || 0;
  if (count <= 0 || count % 2 === 0) return count;
  return count + 1;
}

let k7WipesRemoving = false;

async function k7RemoveWipesVariant(variantId) {
  if (k7WipesRemoving || !variantId) return;
  k7WipesRemoving = true;
  try {
    const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    const updates = {};
    (cart.items || []).forEach((line) => {
      if (String(line.variant_id) === String(variantId)) updates[line.key] = 0;
    });
    if (!Object.keys(updates).length) return;

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) return;
    if (window.themeVariables?.settings?.pageType === 'cart') {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  } finally {
    k7WipesRemoving = false;
  }
}

function k7WipesQuantityFields(form) {
  const fields = new Set();
  Array.from(form.elements).forEach((field) => {
    if (field.name === 'quantity') fields.add(field);
  });
  const formId = form.getAttribute('id');
  if (formId) {
    document.querySelectorAll('[name="quantity"]').forEach((field) => {
      if (field.getAttribute('form') === formId) fields.add(field);
    });
  }
  return Array.from(fields);
}

function k7PrepareDoubledWipesForm(form) {
  if (!(form instanceof HTMLFormElement) || !form.querySelector('[data-k7-double-wipes]')) return;

  const fields = k7WipesQuantityFields(form);
  if (!fields.length) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'quantity';
    input.value = '2';
    form.appendChild(input);
    return;
  }

  fields.forEach((field) => {
    const parsed = parseInt(field.value, 10);
    const next = !Number.isFinite(parsed) || parsed <= 0 ? 2 : k7EvenWipesQuantity(parsed);
    field.value = String(next);
  });
}

function k7BootWipesDouble() {
  if (document.documentElement.dataset.k7WipesDouble === 'true') return;
  document.documentElement.dataset.k7WipesDouble = 'true';

  document.addEventListener('submit', (event) => {
    k7PrepareDoubledWipesForm(event.target);
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-k7-wipes-remove]');
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    k7RemoveWipesVariant(link.getAttribute('data-k7-wipes-remove'));
  }, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', k7BootWipesDouble);
} else {
  k7BootWipesDouble();
}
/* k7 feuchttuecher double end */

